const { APP_NAME, SHORT_DOMAIN, APP_HOST } = window.ThrowdownsConfig;
const year = (new Date()).getFullYear();

export default {
  key: 'nb',
  name: 'norsk (bokmål)',
  messages: {
    defaultCurrency: 'nok',
    email: 'E-post',
    ticket: 'Billett',
    ticketId: 'Billett-ID',
    lastScan: 'Sist innløst',
    totalScans: 'Totale innløsninger',
    buyTickets: 'Kjøpe billetter',
    specTickets: 'Tilskuersbilletter',
    yourTickets: 'Dine billetter',
    print: 'Skrive ut',
    buyMoreTickets: 'Kjøp flere billetter',
    ticketSalesClosedHeader: 'Billettsalg stengt',
    ticketSalesClosedText: 'Billetter er for øyeblikket ikke i salg.',
    loginToBuyTickets: 'For å kjøpe billetter, må du',
    viewTickets: 'Se billetter',
    buyTicketsToday: 'Kjøp billetter i dag!',
    tickets: 'Billetter',
    ticketsPanelHeading: 'Billetter',
    ticketsAddingItem: 'Legger til billett',
    ticketsAddItemButton: 'Legg til billett',
    ticketItemName: 'Billettnavn',
    brandUrlLabel: 'nettsideadresse',
    brandUrlDesc: 'Hvis dette blir gitt, vil denne URL-en bli lenket til logobildet i e-post og på offentlige konkurransesider.',
    marketingSetupUploadLogo: 'Last opp logo',
    marketingSetupPicLogoHelp: `Foreslåtte dimensjoner: 500x500. (Du kan panorere / zoome / beskjære etter opplasting). Hvis du gir et bilde, vil det vises på dine offentlige konkurransesider og i e-postmeldinger som er sendt ut av ${APP_NAME}.`,
    sendersNameOnEmailDesc: `Navnet som vil vises som avsender på automatiserte e-postmeldinger for denne konkurransen. Standardinnstillingen er "${APP_NAME}".`,
    sendersNameOnEmail: 'Senderens navn',
    ticketItemNameDescr: 'Navnet på billettklassen du vil selge (f.eks. VIP, vanlig, student)',
    ticketDescriptionDescr: 'En kort beskrivelse av denne billettklassen',
    ticketDescriptionName: 'Billettbeskrivelse',
    ticketSalesOpen: 'Åpen dato for billettsalg',
    ticketSalesClose: 'Lukk dato for billettsalg',
    ticketingContent: 'Billettsalg',
    ticketingContentLead: 'Dette innholdet vises øverst på siden for billettsalg.',
    fieldTypeChoiceFreeResponseOneLine: 'Gratis svar - One Line',
    fieldTypeChoiceFreeResponseBox: 'Gratis svar - Boks',
    fieldTypeChoiceMultipleChoicePickOne: 'Flervalg - Velg en',
    fieldTypeChoiceMultipleChoicePickOneDropdown: 'Flervalg - Velg en (rullegardin)',
    fieldTypeChoiceMultipleChoiceCanSelectMultipleAnswers: 'Flervalg - Kan velge flere svar',
    pointsTable200Points: '200 poeng',
    pointsTable100Points: '100 poeng',
    pointsTable50Points: '50 poeng',
    pointsTableCustomPoints: 'Egendefinerte poeng',
    HigherisBetter: 'Høyere er bedre',
    LowerisBetter: 'Lavere er bedre',
    tiePolicyTiesStand: 'Slipsene står (Maks Poeng)',
    tiePolicyTiesStandAverage: 'Slipsene står (Gjennomsnittlige Poeng)',
    tiePolicyHigherisBetter: 'Høyere er bedre',
    tiePolicyLowerisBetter: 'Lavere er bedre',
    scoringPolicyPlacement: 'Plassering',
    scoringPolicyMaxPoints: 'Maks poeng',
    scoringPolicyMinPoints: 'Min poeng',
    scoringPolicyPointsTable: 'Poengtabell',
    pointsTableLabelCustom: 'Tilpasset',
    rank: 'Rang',
    leaderboardNameColumnHeader: 'Utøver',
    scorer: 'Scorer',
    yes: 'Ja',
    no: 'Nei',
    cancel: 'Avbryt',
    dashboard: 'Dashbord',
    manage: 'Endre',
    preview: 'Forhåndsvisning',
    registered: 'Registrert',
    submitScores: 'Send inn poeng',
    yourCompetitions: 'Konkurransene dine',
    addCompetition: 'Legg til konkurranse',
    duplicate: 'Duplisere',
    setup: 'Oppsett',
    programming: 'Programmering',
    programmingComplete: 'Programmeringen fullført',
    registration: 'Registrering',
    registrationComplete: 'Registrering ferdig',
    payments: 'Betalinger',
    paymentsComplete: 'Betalinger fullført',
    published: 'Publisert',
    publish: 'Publisere',
    requested: 'Forespurt',
    request: 'Be om',
    inProgress: 'I prosess',
    login: 'Logg Inn',
    location: 'plassering',
    getDirections: 'Få veibeskrivelse',
    date: 'Dato',
    description: 'Beskrivelse',
    addScores: 'Legg til poeng',
    view: 'Utsikt',
    register: 'Registrere',
    now: 'Nå',
    yesUndelete: 'Ja, angre slettingen',
    undelete: 'Angre sletting',
    closed: 'Lukket',
    leaderboards: 'Leaderboards',
    organizedBy: 'Organisert av',
    contactTheOrganizer: 'Kontakt arrangøren',
    getDrivingDirections: 'Få veibeskrivelse',
    workout: 'Trene',
    workouts: 'test',
    division: 'Inndeling',
    divisions: 'Divisjoner',
    shareWithFriends: 'Del med venner',
    athleteRegistration: 'Registrering',
    tryAgain: 'Prøv igjen',
    youreRegistered: 'Du er registrert',
    edit: 'Redigere',
    youAreRegConfirm: `Oppdater din <strong><a href='${APP_HOST}/app/my-account/profile'>utøverprofil</a></strong>`,
    charges: 'Kostnader',
    card: 'Kort',
    registrationFee: 'Registreringsavgift',
    appliedCouponCode: 'Brukte <code>{code}</code>',
    processingFee: 'Behandlingsgebyr',
    charge: 'Lade',
    registerToday: 'Registrer deg i dag',
    loginToRegister: 'For å registrere deg for en konkurranse, må du',
    loginLower: 'Logg Inn',
    dontHaveAccount: 'Har du ikke en konto?',
    createOne: 'Lag en',
    inUnderAMinute: 'på under et minutt',
    alreadyRecorded: 'Du har allerede registrert score. Ingen endringer i registreringen er tillatt.',
    calculatingTotal: 'Beregner total',
    discount: 'Rabatt',
    feeBalance: 'Avgiftsbalanse',
    totalCharge: 'Total kostnad',
    readAndAccept: `Jeg har lest og godtar ${APP_NAME} -avtalen.`,
    readAndAcceptCompt: 'Jeg har lest og godtar {competitionTitle} -avtalen.',
    updateRegistration: 'Oppdater registrering',
    calculateTotal: 'Beregn totalt',
    submitting: 'Resultatregistrering',
    allDivisionsAreFull: 'Alle divisjoner er fulle',
    whatDivision: 'Hvilken klasse vil du registrere deg i?',
    leaderboardName: 'Leaderboard navn',
    leaderboardDescription: 'Navnet du ønsker skal vises på poengoversikten',
    memberFormHeading: 'Teammedlem {memberIndex} / {registrants}',
    registrantName: 'Registrantens navn',
    registrantFirstName: 'Fornavn',
    registrantLastName: 'Etternavn',
    registrantFirstNameDescription: 'Utøverens fornavn',
    registrantLastNameDescription: 'Utøverens etternavn',
    registratioCustomNamesCheckboxMessage: 'Begrens tilpassede leaderboard-navn for individuelle divisjoner',
    registrationCustomNamesDescr: 'Som standard tilbys ikke utøvere i individuelle divisjoner et felt for å legge inn et tilpasset leaderboard-navn. I stedet er deres viste leaderboardnavn deres for- og etternavn. Hvis du ikke merker av for dette alternativet, kan utøvere angi ledertavlenavnet som en hvilken som helst verdi. Denne innstillingen påvirker ikke laginndelingen.',
    registratDescription: 'Utøverens navn',
    registrantEmail: ' Epostadresse',
    registrantEmailDescription: 'Utøverens e-postadresse',
    coupon: 'Kupong',
    couponIsValid: 'Kupongen er gyldig',
    couponIsInValid: 'Kupongen er ugyldig',
    enterCoupon: 'Skriv inn kupongkoden',
    helpfulLinks: 'Hjelpsomme linker',
    privacyTerms: 'Personvern og vilkår',
    throwdownsBlog: `${APP_NAME} -blogg`,
    copyright: `© 2014 - ${year} - ${SHORT_DOMAIN} - Med enerett`,
    rotateLeaderboards: 'Sykle Leaderboards',
    filterAthletes: 'Filtrer utøvere',
    athleteName: 'Utøverens navn',
    noLeaderboard: 'Ingen leaderboard er publisert ennå',
    loading: 'Laster inn ...',
    points: 'Poeng',
    switchDivisions: 'Bytt klasse',
    needPassword: 'Du trenger et passord satt for å kunne logge inn igjen',
    setPassword: 'Lag et passord',
    title: 'Tittel',
    startDate: 'Startdato',
    endDate: 'Sluttdato',
    venueName: 'Stedets navn',
    creatingCompetition: 'Skape konkurranse',
    beginSetup: 'Begynn installasjonen',
    finishSetupComp: 'Finish & Setup-konkurranse',
    continue: 'Fortsette',
    setupWelcomeIntro: `Vi er glade for at du er interessert i ${APP_NAME}`,
    setupWelcomeMain: 'La oss begynne å sette opp din første konkurranse. Bare svar på noen få enkle spørsmål for å komme i gang!',
    setupName: 'Hva heter konkurransen din?',
    myCompetitionName: 'Konkurransens navn',
    setupKindOnline: 'Er <span class="comp-name">{compName}</span> en online konkurranse?',
    setupKindOnlineDescr: 'En online konkurranse er der utøverene dine konkurrerer og sender inn poeng online fra hvor som helst i verden i stedet for å ha dommere som rekordresultater på stedet.',
    goBack: 'Gå tilbake',
    whereCompLoc: 'Hvor skal <span class=\'comp-name\'>{compName}</span> holdes?',
    venueAddress: 'Lokaladresse',
    setupCompDate: 'Når vil <span class="comp-name">{compName}</span> finne sted?',
    timeZoneDescr: 'Tidssonen for de publiserte konkurransetidene',
    timeZoneDescrLabel: 'Tidssone',
    start: 'Start',
    end: 'Slutt',
    setupLastStep: 'Siste steg! Bare en ting til!',
    setupUploadCoverPhoto: 'Last opp et forsidebilde for <span class="comp-name">{compName}</span>',
    suggestedDim: 'Foreslåtte dimensjoner: {width} x {height}',
    dragOrClickPhoto: 'Dra bilde eller klikk for å laste opp',
    finishCropping: 'Fullfør beskjæring',
    imageWarning: 'Bildet ditt er mindre enn anbefalte dimensjoner og vil sannsynligvis være uskarpt. Vi anbefaler minst {recommendedWidth} x {recommendedHeight} og bildet ditt er {width} x {height}.',
    selectDate: 'Velg dato',
    setupCongrats: 'Gratulerer! Du har vellykket å sette opp en konkurranse!',
    setupQuickSteps: 'Landingssiden din er klar! Det er bare noen få raske trinn for å få konkurransen din lansert ...',
    launch: 'Start',
    marketingSetupTitlePage: 'Tittelen på siden din',
    marketingSetupCompName: 'Konkurransens navn',
    marketingSetupCompEmail: 'Svar på e-postadresse',
    marketingSetupCompEmailDesc: `Den primære kontakt-e-postadressen for denne konkurransen. Denne e-postmeldingen vises på dine offentlige konkurransesider. Svar på eventuelle automatiserte e-postadresser for ${APP_NAME} for denne konkurransen vil også bli sendt til denne adressen.`,
    marketingSetupShortlinkDescr: 'Sluggen i konkurransens URL',
    marketingSetupShortlinkTitle: 'Shortlink ID',
    marketingSetupUpload: 'Last opp et forsidebilde',
    marketingSetupMobileUpload: 'Last opp et forsidebilde for mobil (valgfritt)',
    marketingSetupPicHelp: 'Foreslåtte dimensjoner: {width} x {height}. (Du kan panorere / zoome / beskjære etter opplasting)',
    marketingSetupOnlineDescr: 'Er dette en online konkurranse?',
    marketingSetupOnlineTitle: 'Nettkonkurranse',
    invalidDate: 'Det er ikke gyldig å ha en sluttdato / tid før start.',
    programmingWelcome: 'La oss konfigurere programmeringen for {compName}!',
    programmingWelcome2: 'Vi vil gå gjennom treningsøktene, divisjonene og poengretningslinjene dine under denne installasjonsprosessen.',
    programmmingDiv: 'Hvilke divisjoner vil du ha?',
    programmmingEx: 'Vi har lagt til noen få eksempler for å komme i gang. Du kan dra og slippe hver klasse for å endre rekkefølgen på listen.',
    addDivision: 'Legg til klasse',
    dragDropDivision: 'Dra og slipp divisjoner for å endre rekkefølgen.',
    addDivisionGroup: 'Legg til divisjonsgruppe',
    dragDropDivisionGroup: 'Dra og slipp divisjonsgrupper for å endre rekkefølgen.',
    teamSize: 'Lagstørrelse',
    teamSizeDescr: 'Angi det totale antallet lagmedlemmer som kreves for å registrere seg for denne divisjonen. La stå på 1 hvis dette er en solo / individuell registrering.',
    maxRegistrations: 'Maks registreringer',
    maxRegistrationsDescr: 'Angi maksimalt antall registreringer som er tillatt for denne divisjonen.',
    typeOfDivision: 'Type klasse',
    typeOfDivisionDescr: 'Velg hvilken type brukere som skal registrere seg for denne divisjonen. Frivillige divisjoner vil dukke opp ved registrering, men vil ikke ha resultat eller resultat.',
    athlete: 'Atlet',
    volunteer: 'Frivillig',
    spectator: 'Tilskuer',
    nameOfDivision: 'Skriv inn navnet på denne divisjonen.',
    divisionName: 'Divisjonsnavn',
    nameOfDivisionGroup: 'Navnet på gruppen',
    divisionGroupName: 'Gruppenavn',
    loadingDivisions: 'Laster divisjoner',
    saving: 'Lagrer ...',
    save: 'Lagre',
    delete: 'Slett',
    deleteAreYouSure: 'Er du sikker på at du vil slette?',
    deleteFieldItemAreYouSure: 'Er du sikker på at du vil slette dette egendefinerte feltet? Alle data som samles inn av dette spørsmålet, går tapt permanent.',
    deleting: 'Sletter ...',
    programmingWorkouts: 'Hvilke treningsøkter vil du ha?',
    programmingExamples: 'Vi har lagt til noen få eksempler for å komme i gang. Du kan dra og slippe hver treningsøkt for å endre rekkefølgen på listen.',
    addWorkout: 'Legg til test',
    dragDropWorkouts: 'Dra og slipp treningsøktene for å endre rekkefølgen.',
    workoutNameDescr: 'Navnet på testen',
    workoutName: 'Treningsnavn',
    loadingWorkouts: 'Laster inn treningsøkter ...',
    scoringPoliciesUsing: 'Hvilken type poengretningslinjer vil du bruke?',
    scoringLead: 'Disse innstillingene bestemmer hvordan treningsøktene blir scoret, og vil bli brukt til å beregne utøverplassering på ledertavler.',
    dirtyChanges: 'Du har ikke lagrede endringer. Trykk Fortsett lagre endringene.',
    scoringType: 'Poengtype',
    scoringTypeDescr: 'Velg resultat for resultat for rangering som skal brukes.',
    scoringOrder: 'Poengbestilling',
    scoringOrderDescr: 'Velg bestillingspoengene skal rangeres på leaderboard',
    tieBreakerPolicy: 'Retningslinjer for resultatskille',
    tieBreakerPolicyDescr: 'Velg hvordan tie breakers skal løse på leaderboard',
    pointsTablePolicy: 'Poengtabellpolicy',
    pointsTablePolicyDescr: 'Velg antall poeng som skal brukes til å beregne utøverplassering (tabellene 200, 100 og 50 poeng støtter opptil 40 utøvere).',
    goYou: 'Gå du!',
    programmingConfigured: 'Programmering for <span class="comp-name">{compName}</span> er konfigurert!',
    marketingContentTitle: 'Innhold på destinasjonssiden',
    marketingTimeVenueDescr: 'Navnet på lokalet ditt',
    marketingTimeVenueTitle: 'Stedets navn',
    marketingTimeAddressDescr: 'Begynn å skrive gateadressen din',
    marketingTimeAddressTitle: 'Lokaladresse',
    marketingTimeZoneDescr: 'Tidssonen for de publiserte konkurransetidene',
    marketingTimeZoneTitle: 'Tidssone',
    marketingOnlineHeader: 'Online resultat',
    marketingOnlineSubHeader: 'Kontroller hvordan poenginnleveringer håndteres for hver treningsøkt i denne konkurransen.',
    marketingOnlineWorkouts: 'test',
    marketingOnlineInstr: 'Instruksjoner for innsending av poengsummer',
    marketingOnlineVideoTitle: 'Videolink',
    marketingOnlineVideoDescr: 'Må utøveren sende inn en lenke til en video av testen?',
    marketingOnlineImageTitle: 'Bilde',
    marketingOnlineImageDescr: 'Må utøveren sende inn et bilde av testen?',
    marketingOnlineJudgeTitle: 'Dommer',
    marketingOnlineJudgeDescr: 'Er utøveren pålagt å sende inn navnet på personen som vurderte testen?',
    marketingOnlineScoreOpens: 'Scoring åpner',
    marketingOnlineScoreCloses: 'Scoring stenger',
    optional: 'Valgfri',
    required: 'Påkrevd (vil være nødvendig å levere for å levere resultat)',
    notOption: 'Ikke et alternativ (viser ikke inngang)',
    registrationConfig: 'La oss konfigurere registreringen for {compName}!',
    registrationSecondary: 'Vi vil gå gjennom divisjonene dine, datoer, gebyrer og innhold under denne installasjonsprosessen.',
    finish: 'Bli ferdig',
    registrationWhen: 'Når skal registreringen starte og slutte?',
    registrationAvail: 'Velg når registrering for arrangementet ditt vil være tilgjengelig.',
    registrationOpens: 'Registreringen åpner',
    registrationCloses: 'Registreringen stenger',
    registrationCost: 'Hvor mye koster det å registrere seg?',
    registrationFeesSet: 'Registreringsgebyrer kan settes unikt etter klasse.',
    preferredCurrency: 'Foretrukket valuta',
    preferredCurrencyHelp: 'Din foretrukne valuta for transaksjoner. ** Disse valutaene støtter ikke bruken av AMEX.',
    divisionRegistrationFees: 'Divisjonsregistreringsgebyrer',
    registrationContentMain: 'Noe å si mens utøvere registrerer seg?',
    registrationContentSpecial: 'Hvis du ønsker å ha noen spesielle instruksjoner som vises øverst på registreringsskjemaet ditt, for eksempel refusjonsregler eller andre viktige ting for utøvere å vite før du kjøper billetter, kan du legge det til her. Ellers kan du la dette være tomt.',
    registrationConfigured: 'Registreringen for <span class="comp-name">{compName}</span> er konfigurert!',
    accountHeader: 'Kontoen din',
    accountSettings: 'Kontoinnstillinger',
    languagePreference: 'språkpreferanse',
    accountSubscription: 'Abonnement',
    accountEmailAddress: 'Epostadresse',
    accountPassword: 'Passord',
    accountConfirmPassword: 'bekreft passord',
    profileSettings: 'Profilinnstillinger',
    profileUsername: 'Brukernavn',
    profileUsernamePlaceholder: 'Skriv inn et brukernavn',
    profileUsernameCanBeSetOnce: 'Brukernavnet ditt kan bare angis en gang og kan ikke endres.',
    profileSetUsername: 'Angi brukernavnet ditt for å redigere profilinformasjonen din.',
    profileGender: 'Kjønn',
    profileName: 'Navn',
    profileFirstNamePlaceholder: 'Fornavn',
    profileLastNamePlaceholder: 'Etternavn',
    profileDisplayName: 'Visningsnavn',
    profileDisplayNamePlaceholder: 'Foretrukket visningsnavn på leaderboards',
    profileBio: 'Om meg',
    profileBioPlaceholder: 'Det er her du kan sende inn ytterligere detaljer om deg selv som utøvere! Mange av brukerne våre inkluderer emner som:\n\n      - Treningsrutine\n      - Kosthold\n      - Konkurransehøydepunkter\n      - Hobbyer\n\nOg mer! Du kan alltid komme tilbake og redigere biografien din når som helst hvis du ikke er sikker på hva du skal si akkurat nå.',
    profileAssociationsHeader: 'Foreninger',
    profileCountry: 'Land',
    profileAffiliate: 'Tilknytte',
    profileAffiliatePlaceholder: 'Hvor du trener',
    profileSocialHeader: 'Sosiale profiler',
    profileTwitterHandlePlaceholder: 'Twitter-håndtaket ditt',
    profileFacebookUsernamePlaceholder: 'Ditt Facebook-brukernavn',
    profileInstagramHandlePlaceholder: 'Instagram-håndtaket ditt',
    profileMustSetUsernameToSave: 'Du må angi brukernavnet ditt for å lagre profilen din.',
    profilePublic: 'Profilen er offentlig.',
    profilePrivate: 'Profilen er privat.',
    profilePublicLink: 'Profillink',
    profilePublicLinkDescr: 'En lenke for å dele din offentlige profil.',
    athleteAthleteBio: 'Utøver Bio',
    athleteUsernameNotFound: 'Det ser ut til at profilen ikke eksisterer.',
    athleteNoBio: 'Denne utøveren har ikke gitt noen bioinformasjon ennå.',
    unspecified: 'Uspesifisert',
    onlineScoring: 'Online resultat',
    content: 'Innhold',
    timeAndPlace: 'Tid og sted',
    help: 'Hjelp',
    coupons: 'Kuponger',
    customWaiver: 'Tilpasset avtale',
    customFields: 'Egendefinerte felt',
    scoringPolicies: 'Poengregler',
    marketing: 'Markedsføring',
    guidedSetup: 'Veiledet oppsett',
    retail: 'Detaljhandel',
    fees: 'Avgifter',
    dates: 'Datoer',
    deposits: 'Innskudd',
    advanced: 'Avansert',
    registrants: 'Registranter',
    scoreEntry: 'Poengoppføring',
    management: 'Ledelse',
    support: 'Brukerstøtte',
    dataEntryLinks: 'Koblinger til datainnføring',
    leaderboardSettings: 'Leaderboard-innstillinger',
    noContent: 'Ikke noe innhold',
    editContent: 'Rediger innhold',
    registrationContent: 'Registreringsinnhold',
    registrationLead: 'Hvis du ønsker å ha noen spesielle instruksjoner som vises øverst på registreringsskjemaet ditt, for eksempel refusjonsregler eller andre viktige ting for utøvere å vite før du kjøper billetter, kan du legge det til her. Ellers kan du la dette være tomt.',
    connectToAStripeAccount: 'Koble til en Stripe-konto',
    connectToNewStripeAccount: 'Koble til ny stripekonto',
    stripeLead: 'Vi samarbeider med Stripe, bransjens beste betalingsprosessor, slik at du alltid har full kontroll over registreringsmidlene dine.',
    stripeNotConnected: 'Du har ikke koblet til en Stripe-konto ennå',
    letsDoThatNow: 'La oss gjøre det nå',
    yourStripeAccounts: 'Stripe-kontoene dine',
    yourStripeAccountsDescr: 'Hvilke av disse Stripe-kontoene skal motta innskudd til denne konkurransen?',
    depositsNeedHelp: 'Trenger du hjelp med innskudd? Kontakt oss på',
    youWillReceive: 'Du vil motta betaling på <strong>{acctName}</strong> Stripe-kontoen din.',
    stripeOptOut: 'Siden du har valgt å ikke bruke Stripe, vil vi samle inn registreringsavgiftene for deg. Midler frigjøres 45 dager etter at konkurransen din er over, og etter å ha vurdert et behandlingsgebyr på $ 150.',
    registrantDivisionTitle: '{divTitle} Registranter',
    registrantsExport: 'Forbered eksport',
    registrantsExportPrep: 'Forbereder...',
    registrantsExportView: 'Vis eksport',
    registrantsLeaderboardName: 'Leaderboard navn',
    registrantsTeamMembers: 'Lag medlemmer',
    registrantsAthleteName: 'Utøverens navn',
    registrantsDate: 'Registrert kl',
    registrantsCharges: 'Kostnader',
    registrantsChangeDivision: 'Endre klasse',
    registrantsAddDivision: 'Legg til registrering',
    addCoupon: 'Legg til kupong',
    loadingCoupons: 'Laster inn kuponger ...',
    registrationWaiverContent: 'Registreringsfraskrivelsesinnhold',
    registrationWaiverContentLead: 'Denne standardfraskrivelsen skal fungere bra, men hvis du har deg som du vil registrere utøvere til å godta, er det bare å erstatte den.',
    addField: 'Legg til felt',
    customRegistrationFields: 'Egendefinerte registreringsfelt',
    loadingRegistrationFields: 'Laster inn registreringsfelt',
    label: 'Merkelapp',
    labelDescr: 'Etiketten for ditt felt.',
    helpText: 'Hjelpeteksten for ditt felt. Denne teksten er \'hjelpetekst\'',
    helpTextLabel: 'Hjelpetekst',
    requiredField: 'Krev at dette feltet skal fylles ut under registrering',
    requiredFieldLabel: 'Påkrevd',
    team: 'Team',
    teamField: 'Lagspørsmål',
    teamFieldLabel: 'Dette spørsmålet blir bare stilt en gang per registrering',
    fieldChoices: 'Valg for dette feltet atskilt med komma',
    fieldChoicesLabel: 'Feltvalg',
    fieldPreview: 'Forhåndsvisning av felt',
    couponCode: 'Kupongkode',
    percentageOff: 'Prosentandel av',
    amountOff: 'Beløp av',
    numberAvailable: 'Antall tilgjengelige',
    expiration: 'Utløp',
    add: 'Legge til',
    editCoupon: 'Rediger kupong',
    scoringLink: 'Scoringslenke',
    shareThisLink: 'Del denne private og sikre lenken med personalet for å få hjelp til å score',
    shareThisTicketLink: 'Del denne private og sikre lenken med personalet for å få hjelp til å administrere billetter',
    scoring: 'Scorer',
    previewLeaderboard: 'Forhåndsvisning av leaderboard',
    publishedLeaderboard: 'Publisert Leaderboard',
    refreshing: 'Forfriskende',
    enterScoresStatement: 'Skriv inn noen poeng i kategorien Poeng for å generere en forhåndsvisning på denne kategorien.',
    publishedLeaderboardLink: 'Dette er det publiserte leaderboardet som er tilgjengelig på',
    noLeaderboardPublishedStatement: 'Du har ikke publisert et leaderboard for denne divisjonen ennå. Skriv inn noen poeng i kategorien Poengvurdering, og publiser deretter et leaderboard fra forhåndsvisning av leaderboard-fanen.',
    youMadeChangesStatement: 'Du har gjort endringer i registreringen. Forhåndsvisning av ledertavlen og publiser for å gjøre live.',
    noScoresDivision: 'Det er ingen score for denne divisjonen. Legg til nye poeng nedenfor.',
    name: 'Navn',
    addNew: 'Legg til ny',
    score: 'Resultat',
    tieBreaker: 'Resultatskille',
    review: 'Anmeldelse',
    yourScores: 'Resultatene dine',
    scoresFor: 'Poeng for',
    mustAuth: 'Du må godkjenne for å registrere poengene dine',
    instructions: 'Veiledning',
    scaled: 'Skalert',
    video: 'Video',
    withdraw: 'trekk',
    scoringClosed: 'Scoring stengt',
    withdrawing: 'Trekke tilbake',
    scoringIsOpenFrom: 'Registreringen er åpen fra',
    addScore: 'Legg til resultat',
    scoringIsClosed: 'Registreringen er stengt',
    window: 'vindu',
    scoreDescr: 'Hva var registreringen din?',
    timeScoreDescr: 'Angi tiden det tok å fullføre hele testen.',
    repScoreDescr: 'Angi antall repetisjoner du klarte å fullføre innen tidsbegrensningen.',
    tieBreakDescr: 'Hva var uavgjort?',
    certification: 'Sertifisering',
    rx: 'Rx',
    rxCertifyStatement: 'Jeg fullførte testen i henhold til de skriftlige standardene for denne divisjonen.',
    scaledCertifyStatement: 'Jeg forstår at poengene mine vil ligge under utøvere som fulgte standardene i denne divisjonen.',
    selectRxStatement: 'Velg Rx hvis du fullførte testen i henhold til standardene <strong>for divisjonen din</strong> . Ellers velger du Skalert for å indikere at du skalerte testen utover standardene <strong>for divisjonen din</strong> .',
    certificationHelp: 'Merk av i denne boksen hvis du ikke endret standardene for divisjonen din (lettere vekter, modifiserte bevegelser osv.)',
    certificationDescription: 'Hvis du lar denne boksen stå tom, betyr det at du endret testen på en eller annen måte. Resultatene dine vises nederst på poengoversikten.',
    videoLink: 'Videolink',
    videoLinkDescr: 'Lenke til en YouTube eller annen vertsvideo av testen din',
    imageLink: 'Bilde',
    imageLinkDescr: 'Last opp et bilde som skal brukes til poengverifisering',
    judge: 'Dommer',
    judgeDesc: 'Navnet på personen som dømte testen din',
    comments: 'Kommentarer',
    expired: 'Utløpt',
    expiresOn: 'Går ut på dato den',
    extend: 'Forlenge',
    expire: 'Utløpe',
    activate: 'Aktiver',
    deactivate: 'Deaktiver',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    externalScoreThanks: 'Takk for at du hjelper registreringen!',
    hangTight: 'Hold deg fast',
    exitWithoutSavingSure: 'Er du sikker på at du vil avslutte uten å lagre?',
    continueEditing: 'Fortsett redigering',
    exitWithoutSaving: 'Avslutt uten å lagre',
    finalReviewStatement: 'Konkurransen din er under endelig gjennomgang før du går live!',
    dashboardSummary: 'Et sammendrag av hvordan konkurransen din går.',
    summary: 'Sammendrag',
    revenue: 'Inntekter',
    views: 'Visninger',
    registrations: 'Registreringer',
    outOf: 'ut av',
    divisionCapacity: 'Divisjonskapasitet',
    by: 'av',
    cumulativeTotalRevenue: 'Kumulativ totalinntekt',
    performance: 'Opptreden',
    regAndTrafficStatement: 'Registreringer og trafikk til konkurranse destinasjonssiden over tid.',
    scoreSubmissionHeader: 'Resultatregistrering av utøvere',
    athleteAlreadyExists: 'Utøver allerede inn',
    workoutSubmitScore: 'Send inn resultat',
    only: 'kun',
    spots: 'flekk | flekker',
    remaining: 'gjenstående',
    stripeDeclined: 'Kortet ditt ble avvist.',
    stripeInsufficient: 'Kortet ditt har ikke nok midler.',
    twitterMessage: '{compName} ser flott ut. Sjekk ut dette:\n\n{href}',
    shareEmailSubject: 'Ta en titt på {compName}',
    shareEmailMessage: '{compName} ser flott ut. Sjekk ut dette:\n\n{href}',
    deleteCouponMessage: 'Er du sikker på at du vil slette <strong>{code}</strong> -kupongen?',
    unsupportedBrowHead: 'Ustøttet nettleser',
    unsupportedBrowButton: 'OK',
    unsupportedBrowDescr: 'Det ser ut til at du bruker en eldre nettleser som ikke støttes. Du kan få problemer med å bruke appen. Oppgrader for å sikre at du får den beste opplevelsen.',
    networkErrorHead: 'Nettverksfeil',
    networkErrorButton: 'Prøv igjen',
    networkErrorDescr: 'Nettverkstilkoblingen din ble tapt.',
    clipboardCopy: 'Kopiert!',
    waiverClose: 'Lukk Waiver',
    waiverShow: 'Vis avkall',
    couponDiscount: '{discount}% avslag',
    failedRegistration: 'Det var et problem',
    competitionFullHeader: 'Konkurransen er full',
    divisionsFullDescr: 'Alle divisjoner er utsolgt. Ta kontakt med arrangøren for å høre om venteliste.',
    invitationInviteesCount: 'Invitert (er)',
    registrationRequiredFieldsWarning: 'Fyll ut alle obligatoriske felt.',
    subtotal: 'Delsum',
    regCardEndingMessage: 'Du utfører denne transaksjonen på et kort som slutter med',
    merchandise: 'Handelsvarer',
    orderMerchItem: 'Punkt',
    orderMerchPrice: 'Pris',
    orderMerchQty: 'Antall',
    orderMerchSoldOut: 'Utsolgt',
    orderMerchCouponDis: 'Kupongrabatt',
    orderMerchSubtotalDis: 'Rabatt delsum',
    orderMerchNow: 'Bestill nå',
    merchHeader: 'Detaljhandel',
    merchAddItem: 'Legg til en salgsartikkel',
    merchQty: 'Opprinnelig mengde',
    merchQtyDescr: 'Hvor mange av disse har du tilgjengelig for salg?',
    merchExchangeable: 'Utskiftbar',
    merchExchangeableDescr: 'Er denne varen noe som kan byttes mot en annen vare?',
    merchItemName: 'Gjenstandsnavn',
    merchItemNameDescr: 'Navnet på varen som er til salgs',
    addItemDescrHeader: 'Vare Beskrivelse',
    addItemDescrDescr: 'En kort beskrivelse av varen din',
    merchImageUpload: 'Last opp et bilde for varen',
    merchImageHelp: 'Foreslåtte dimensjoner: {width} x {height}. (Du kan panorere / zoome / beskjære etter opplasting)',
    merchLoading: 'Laster inn varer til salgs ...',
    orderMerchButton: 'Bestill varer',
    editDetailsButton: 'Rediger detaljer',
    releaseTime: 'Utgivelsestid',
    releaseTimeDescription: 'Velg tidspunktet du vil at treningsdetaljene dine skal avsløres for utøvere. test før "Release Time" vil ha en plassholder av "TBA Workout".',
    invalidVideo: 'Ugyldig video',
    athleteComment: 'Utøver Kommentar',
    exportAsCSV: 'Eksporter som CSV',
    scoringImportAthletes: 'Import',
    scoringImportAthletesDescr: 'Lim inn navnene på utøverene dine for å legge dem til i poengsumtabellen.',
    importingAthletes: 'Importerer ...',
    bibNumbers: 'Smekke nummer',
    enterBibNumber: 'Skriv inn smekknummer',
    toggleBibs: 'Veksle smekker',
    merchReceiptQty: 'Mengde',
    merchPurchasedItems: 'Kjøpte varer',
    registrationClosedBody: 'Påmelding stengt',
    registrationClosedBodyDescr: 'Påmeldingen er nå stengt.',
    noWorkoutFound: 'Ingen treningsøkt funnet',
    noWorkoutFoundDescr: 'Denne testen eksisterer ikke.',
    noDivisionFound: 'Ingen klasse funnet',
    noDivisionFoundDescr: 'Denne inndelingen eksisterer ikke.',
    competitionCard: {
      duplicateAlert: 'Er du sikker på at du vil duplisere denne konkurransen?'
    },
    divisionTeamReqMessage: '{teamSize} - medlemsteam kreves',
    throwdownsWaiver: '<h4>Forutsetning om risiko og avtalsdeltakelse Frigjøring av ansvar</h4><p> Av hensyn til å få delta på noen måte i programmet, relaterte arrangementer og aktiviteter, erkjenner jeg og godtar at:</p><ul><li> Risikoen for skade fra aktivitetene som er involvert i dette programmet er betydelig, inkludert potensialet for permanent lammelse og død.</li><li> Jeg tar bevisst og fritt alle slike risikoer, både kjente og ukjente, selv om jeg stiger fra løslatelsen eller andres uaktsomhet, og tar fullt ansvar for min deltakelse.</li><li> Jeg godtar villig å overholde vilkårene for deltakelse. Hvis jeg observerer noen uvanlig betydelig fare under tilstedeværelsen eller deltakelsen, vil jeg fjerne meg fra å delta og bringe dette til nærmeste tjenestemann umiddelbart.</li><li> Jeg, for meg selv, og på vegne av mine arvinger, eksekutører, administratorer, personlige repetisjoner, etterfølgere og tildeler, frafaller og frigjør alle rettigheter, krav og handlinger jeg har eller måtte ha mot arrangørene eller noen som er tilknyttet enheten , det er primærsponsor og dets tilknyttede selskaper, deres agenter, ansatte, offiserer, styremedlemmer, etterfølgere og oppdragere, arrangementslederfirmaet, byen, parkdistriktene, og alle sponsorer, deres repetisjoner og etterfølgere, som kan oppstå som et resultat av min deltakelse i arrangementet og eventuelle aktiviteter før og etter arrangementet.</li><li> Jeg bekrefter og bekrefter at jeg er fysisk i form og har trent tilstrekkelig for å fullføre dette programmet, relaterte hendelser og / eller relaterte aktiviteter, og en lisensiert medisinsk lege har bekreftet min fysiske tilstand.</li><li> Videre gir jeg herved full tillatelse til alt det foregående til å bruke fotografier, film, opptak eller annen registrering av denne hendelsen til ethvert legitimt formål, inkludert kommersiell reklame.</li><li> Jeg bekrefter at jeg enten er 18+ eller at jeg har foreldrenes samtykke til å delta i anstrengende fysisk test.</li></ul>',

    setupProgramming: '@:setup @:programming',
    setupRegistration: '@:setup @:registration',
    setupPayments: '@:setup @:payments',
    publishRequested: '@:publish @:requested',
    requestPublish: '@:request @:publish',
    viewRegistration: '@:view @:registration',
    registerNow: '@:register @:now',
    buyTicketsHeader: 'Kjøp billetter i dag',
    registrationClosed: '@:registration @:closed',
    registrationSuccess: 'Registrering fullført',
    noWorkoutForThisDivision: '@:no @:workouts er blitt @:announced ennå',
    noDivisionsForThisWorkout: '@:no @:divisions for denne @:workout',
    yesDelete: '@:yes, @:delete',

    heatScheduling: 'Planlegging',
    heatsSubMenu: 'Administrer varme',
    heatsLocations: 'Steder',
    heatsWorkoutLocations: 'Treningssteder',
    heatsSchedules: 'Tidsplaner',
    heatsSegments: 'Segmenter',
    athleteAssignmentsLabel: 'Utøvere',
    heatManageAssignments: 'Heat and Lane Assignments',
    heatsManageTimes: 'Heat Times',
    schedule: 'Tidsplan',
    heatsJudges: 'Dommere',
    loadingLocations: 'Laster inn steder ...',
    addLocation: 'Legg til plassering',
    heatsWorkoutParams: 'Treningsparametere',
    workoutDurationDesc: 'Hvor lang tid (minutter) som er gitt for en utøvereå fullføre denne testen',
    workoutDurationLabel: 'Varighet',
    configStartEnd: 'Tid',
    actualStartEnd: 'Tid',
    workoutTransitionTimeDesc: ' Mengden tid (minutter) som er tildelt for overgang mellom utøvere',
    workoutTransitionTimeLabel: 'Overgangstid',
    workoutNumberOfLanesDesc: 'Antall baner tilgjengelig for denne testen',
    workoutNumberOfLanesLabel: 'Antall baner',
    workoutTimeCapDescr: 'Tidsgrensen for denne testen er {timeCap}',
    workoutTimeCapAllRepsCompleted: '<strong>Alle {totalRepsInWorkout} repetisjoner</strong> ble fullført innen tidsgrensen.',
    workoutTimeCapFewerRepsCompleted: '<strong>Færre enn {totalRepsInWorkout} repetisjoner</strong> ble fullført innen tidsgrensen.',
    heatsLaneEmpty: '{laneLabel} Tom',
    heatsJudgeLaneEmpty: 'Lane er tom',
    heatsLane: 'Lane {athleteIndex}',
    heatsPending: 'Felt tomt',
    calculating: 'Beregner ...',
    publishing: 'Publisering ...',
    heatsStartEnd: 'Start- og sluttider',
    heatsStartEndDescr: 'Ønsket start- og sluttid for dagsplanen',
    heatsTransTime: 'Overgangstid',
    heatsTransTimeDescr: 'Overgangstiden mellom gjennomføring av en treningsøkt / klasse og starten av den neste. Øker med 5 minutter.',
    lane: 'Kjørefelt',
    backToTop: 'Tilbake til toppen',
    back: 'Tilbake',
    next: 'Neste',
    empty: 'Tømme',
    printCancel: 'Avbryt utskrift',
    heatsNoPlans: 'Ingenting planlagt',
    heatsStageWorkouts: 'test for dette stedet',
    heatsStageWorkoutsDescr: 'Velg og bestill treningsøktene som vil skje på dette stedet for hver dag i konkurransen.',
    stageNameDescr: 'Navnet på stedet du oppretter. Eksempel: Pull-up Rack, Barbell Platform, Lake, Track, etc.',
    locationName: 'Stedsnavn',
    schedulingConfig: 'Takk for at du prøvde planleggeren vår',
    schedulingSecondary: 'Vi oppdaterer og forbedrer kontinuerlig hvordan planleggeren fungerer, og vil gjerne høre din tilbakemelding! Resten av denne veiviseren vil lede deg gjennom opprettelsen av timeplanen din.',
    schedulingSegments: 'På dette trinnet vil du angi start- og sluttider for hvert segment av konkurransen. Vi har levert noen standardsegmenter for deg basert på antall dager konkurransen din kjører.',
    schedulingStages: 'På dette trinnet vil du opprette treningsstedene dine og tilordne treningsøkter til dem. Tenk på lokasjoner når de forskjellige stasjonene eller treningsøktene vil bli fullført i. Vi har gitt eksempler på steder for deg.',
    schedulingWorkouts: 'På dette trinnet vil du justere de forskjellige treningsparametrene du har tildelt stedene dine. Disse parametrene inkluderer varighet, overgangstid og antall baner. Vi har gitt noen standardinnstillinger for å komme i gang.',
    schedulingConfigured: 'De første trinnene for å lage heat-planen din er vellykket konfigurert!',
    schedulingFinal: 'Deretter går du videre til kategorien Planlegging, hvor du kan se hvordan timeplanene dine blir \'skiver\' i forskjellige tidsseksjoner.',
    schedulePageTitle: 'Tidsplan',
    scheduleYours: 'Tidsplanen din',
    loginSchedule: 'For å se tidsplanen din,',
    missingDataWarning: 'Konkurransen din er ikke passende konfigurert for at planleggeren skal kunne kjøre. Hvis du vil utforme en tidsplan, må du løse følgende krav og sjekke tilbake her:',
    noDivisionsWarning: 'Ingen divisjoner er definert for denne konkurransen.',
    noWorkoutsWarning: 'Ingen treningsøkter er definert for denne konkurransen.',
    noStagesWarning: 'Ingen steder er definert for denne konkurransens tidsplan.',
    schedulingInfo: 'Fra denne fanen kan du se og administrere de forskjellige segmentene du har opprettet. Klikk på rullegardinikonet for å få en detaljert oversikt over segmentet ditt, der du kan angi divisjonsrekkefølge og etablere globale overgangstider',
    schedulingPanelInfo: 'Nedenfor er de forskjellige delene av konkurransen din. Inndelinger kan ordnes i hvert stykke.',
    schedulePageInfo: 'Ingen tidsplan er publisert ennå for denne konkurransen. For mer informasjon, kontakt arrangøren av arrangementet ved hjelp av e-postadressen nedenfor.',
    confirmPublish: 'Bekrefte',
    addSegment: 'Legg til segment',
    segmentTitle: 'Merkelapp',
    segmentTitleDesrc: 'Hva heter denne dagen (f.eks. Dag 1, torsdag osv.)?',
    loadingSegments: 'Laster inn segmenter ...',
    heatsDraft: 'Utkast',
    minute: 'minutt',
    minutes: 'minutter',
    second: 'sekund',
    seconds: 'sekunder',
    seedingInfo: 'Fra denne kategorien kan du endre atlete såing. Tilfeldig såing av utøverne dine har automatisk blitt brukt. Klikk på rullegardinikonet for å overstyre denne såingen på en utøvereetter sakssak. Lavere tall indikerer såing med høyere rangering (1> 4).',
    manageHeatsInfo: 'Fra denne fanen kan du se og administrere heats for hver plan du har opprettet. Du kan stille inn varmetiden manuelt ved å velge knappen Rediger tid.',
    timeBlockLabel: 'Bare tidsboks',
    timeBlockDesc: 'Dette segmentet vil ikke ha noen heats, men bare være en tidsboks på timeplanen din.',
    timeBlockCheckBoxText: 'Ja, flagg som et tidsbokssegment.',
    expand: 'Utvide',
    heatsNoJudges: 'Ingen dommere tildelt ennå',
    configuration: 'Konfigurasjon',
    defaultErrorMessageSavingJudgeName: 'Feil ved lagring. Prøv igjen!',
    heatsNoHeatsSegment: 'Ingenting planlagt for dette segmentet ennå',
    deleteConfirm: 'Slett',
    schedulePublishWarning: 'Det vil gjøre tidsplanen offentlig og la utøvere kunne se sine personlige heats.',
    scheduleUnpublishWarning: 'Oppheving av publisering fjerner tidsplanen fra den offentlige destinasjonssiden og skjuler utøverenes personlige heats. Er du sikker?',
    heatsLastSegmentWarning: 'Du må ha minst ett segment, og dette er det eneste du har.',
    heatsLastLocationWarning: 'Du må ha minst ett treningssted, og dette er det eneste du har.',
    heatsDeletePublishedLocationWarning: 'Ett eller flere av segmentene dine som bruker denne plasseringen, er i en offentliggjort tidsplan.',
    heatsSchedulesNoWorkout: 'Ingen treningsøkter tildelt.',
    heatsSchedulesAssignWorkout: 'Tilordne noen.',
    heatsSchedulesInvalidWarning: 'Ugyldige parametere. Kunne ikke beregne tidsplanen.',
    heatsSeedsNoAthletes: 'Ingen utøvere registrerte seg for denne divisjonen',
    heatsFetchRegistrations: 'Henter registreringer ...',
    heatsHeatsJudgesInvalidSchedule: 'Tidsplanen for dette segmentet er ugyldig. Korriger for å fortsette.',
    heatsSchedulesPublishedWarning: 'Du kan ikke gjøre noen endringer her fordi dette segmentets tidsplan er publisert.',
    heatsCreated: 'Laget',
    heatsSchdulesTimeOverSegmentWarning: 'Tidsplanen din er <strong>{timeOver} minutter</strong> etter slutten av segmentet. Du kan justere overgangstiden mellom divisjoner, treningsparametere og / eller sluttid for segmentet for å løse dette.',
    heatsPreviewInstructions: 'Dette er en forhåndsvisning av hva som vil bli publisert på destinasjonssiden din. Hvert <em>segment</em> publiseres individuelt, slik at du kan rulle ut tidsplanen når du er klar.',
    heatsPreviewRegOpenWarning: 'Kan ikke publisere før registreringen stenger',
    unpublish: 'Fjern publiseringen',
    confirmUnpublish: 'Fjern publiseringen',
    areYouSure: 'Er du sikker?',
    areYouSurePublish: 'Er du sikker på at du er klar til å publisere?',
    areYouSureUnpublish: 'Er du sikker på at du er klar til å publisere?',
    unpublishWarningIntro: 'Etter at du har publisert, kan visse handlinger føre til at timeplanen din blir fullstendig gjenopprettet:',
    unpublishWarningDivisions: 'Legge til eller slette divisjoner',
    unpublishWarningWorkouts: 'Legge til eller slette treningsøkter',
    unpublishWarningAdvancedWorkouts: 'Ekskluderer eller inkluderer treningsøkter på divisjoner som en del av avansert poengstyring',
    unpublishWarningWorkoutHeats: 'Endring av treningsparametere',
    unpublishWarningWorkoutLocations: 'Legge til eller slette treningssteder',
    unpublishWarningWorkoutLocationsConfig: 'Endrer konfigurasjonen av treningsstedene',
    unpublishWarningSeeding: 'Modifiserende utøver såing',
    unpublishWarningBody: 'Hvis du gjør noe av det ovennevnte etter at du har publisert, vil du føre til en fornyelse av timeplanen din. Dette betyr at alle dommere du har skrevet inn vil gå tapt, og tid / steder som utøverene dine allerede har sett vil sannsynligvis endre seg.',
    pleaseConfirm: 'Vennligst bekreft',
    unpublishWarningTypePublish: 'Skriv \'unpublish\' for å bekrefte at du virkelig vil gjøre dette.',
    heatsPreviewInvalidWarning: 'Tidsplanen er ikke gyldig. Rett før publisering.',
    heatInvalidStartHere: 'Start her.',
    publishedScheduleWarningHeader: 'Du har en publisert tidsplan',
    publishedScheduleWarningBody1: 'Du må',
    publishedScheduleWarningBody2: 'opphev publiseringen',
    publishedScheduleWarningBody3: 'for å gjøre endringer.',
    launchModalHeader: 'har blitt sendt til vurdering!',
    launchModalLead1: 'Rått! Du har opprettet konkurransen og sendt den til oss for gjennomgang.',
    launchModalLead2: 'Våre ansatte vil:',
    launchModalList1: 'Gjennomgå konkurransedetaljene dine',
    launchModalList2: 'Kontakt deg om våre forskjellige betalingsalternativer',
    launchModalList3: 'Bekreft datoen du vil publisere konkurransen',
    launchModalLead3: 'Vi er stolte av å samarbeide med deg i en fantastisk konkurranse!',
    launchModalButton: 'Flott! La oss gjøre det!',
    intentModalHeader: `Velkommen til ${APP_NAME}!`,
    intentModalIntro: 'Vi er glade for å komme i gang! Hjelp oss med å tilpasse opplevelsen din ved å fortelle oss om deg selv.',
    intentModalOptionSelect: 'Jeg vil:',
    intentModalParticipant: 'Jeg er en deltaker',
    intentModalParticipantDescr1: 'Registrer deg for en konkurranse',
    intentModalParticipantDescr2: 'Se leaderboards',
    intentModalParticipantDescr3: 'Oppdag nye konkurranser',
    intentModalParticipantButton: 'Start her',
    intentModalOrganizer: 'Jeg er en arrangør',
    intentModalOrganizerDescr1: 'Lag og administrer en konkurranse',
    intentModalOrganizerDescr2: 'Legg til / vurder poeng',
    intentModalOrganizerDescr3: 'Publiser leaderboards',
    intentModalOrganizerButton: 'Start her',
    intentModalSpectator: 'Jeg er en tilskuer',
    intentModalSpectatorDescr1: 'Kjøp billetter til en konkurranse',
    intentModalSpectatorDescr2: 'Se leaderboards',
    intentModalSpectatorDescr3: 'Oppdag nye konkurranser',
    intentModalSpectatorButton: 'Start her',
    dashboardOrganizerNoComps: 'Du har ikke opprettet noen konkurranser ennå. <strong>Legg til en konkurranse for</strong> å komme i gang!',
    dashboardParticipantNoComps: 'Du er for øyeblikket ikke registrert for noen konkurranser. <strong>Finn en konkurranse for</strong> å komme i gang!',
    dashboardSpectatorNoComps: 'Du har for øyeblikket ikke billetter til noen konkurranser. <strong>Finn en konkurranse for</strong> å komme i gang!',
    scoresubModalClose: 'Lukk',
    athleteToggle: 'Deltager',
    organizerToggle: 'Arrangør',
    spectatorToggle: 'Tilskuer',
    findCompButton: 'Finn en konkurranse',
    findCompHeader: 'Finn en konkurranse',
    findCompSearchHeader: 'Søk etter en konkurranse',
    findCompSearchDescr: 'Søk etter en konkurranse etter navn for å finne en du er interessert i å registrere deg for',
    findCompSearchResults: 'Søkeresultater',
    findCompResultLandingPage: 'Destinasjonsside',
    findCompFetchLocation: 'Henter posisjon ...',
    findCompUseLocation: 'Bruk Min posisjon',
    findCompFetchSuggestions: 'Henter forslag ...',
    findCompRecentlyViewed: 'Nylig sett',
    findCompNoSuggestions: 'Ingen forslag funnet.',
    findCompFetchSearchResults: 'Henter søkeresultater ...',
    findCompNoSearchResults: 'Vi fant ingen konkurranser som samsvarer med søkeordene dine.',
    findCompSuggestions: 'Forslag',
    registrationCap: 'Registrering Cap',
    athleteRegistrationCap: 'Angi maksimalt antall utøverregistreringer du vil akseptere for denne konkurransen. Registreringsgrenser for individuell klasse gjelder fortsatt, men vil bli erstattet av registreringsgrensen. La feltet stå tomt og lagre for å fjerne atleten.',
    noRegistrationCap: 'Ingen registreringsgrense definert.',
    totalRepsInWorkout: 'Totalt antall rep',
    totalRepsInWorkoutNA: 'Totalt antall repetisjoner - ikke relevant',
    totalRepsInWorkoutDescr: 'Hvis denne testen har en tidsbegrensning og innebærer å telle antall fullførte reps, må du angi det totale antallet reps for testen.',
    minimumWorkNotMet: 'Minimum arbeid ikke oppfylt',
    minimumWorkRequired: 'Minimum arbeid påkrevd',
    minimumWorkRequiredDescr: 'Hvis en utøveres poengsum ikke oppfyller eller overstiger denne verdien for treningen, vil de bli flyttet til bunnen av det generelle poenglisten.',
    timeCap: 'Tidsbegrensning',
    timeCapDescr: 'Hvis denne treningen har en tidsbegrensning, angir du den med timer, minutter og sekunder.',
    acceptTerms: 'Jeg godtar',
    latestTerms: 'siste vilkår for bruk',
    submitConsent: 'Aksepterer',
    tosUpdated: 'Våre vilkår for bruk er oppdatert!',
    launchPublishModal: 'Start konkurransen!',
    readyToLaunch: 'La oss gjøre dette!',
    areYouReadyToLaunch: '<p class=\'lead\'>Start konkurransen</p><p> Det er gratis for deg å starte en konkurranse. Deltakerne betaler behandlingsgebyr når de registrerer seg i henhold til vilkårene for bruk.</p>',
    bibNumber: 'Smekke #',
    registrationAccess: 'Registreringstilgang',
    registrationAccessHeader: 'Registreringstilgang',
    registrationAccessCheckboxMessage: 'La utøvere oppdatere registreringen',
    registrationAccessDescr: 'Som standard er utøvere i stand til å oppdatere registreringsinformasjonen når som helst. Dette inkluderer endring av tilpassede feltsvar, samt bytte avdeling. Hvis du ikke merker av for dette alternativet, forhindrer utøvere å kunne oppdatere registreringsinformasjonen eller endre klasse etter registrering.',
    regDetailDescription: 'Beskrivelse',
    regDetailQuantity: 'Mengde',
    regDetailRegistration: 'Registrering',
    regDetailPurchases: 'Innkjøp',
    regDetailAdd: 'Legge til',
    regDetailDivision: 'Inndeling',
    regDetailBib: 'Smekke #',
    regDetailLeaderboardName: 'Leaderboard navn',
    regDetailTeamMember: 'Teammedlem #',
    regDetailEmail: 'E-post',
    invitationsMenuLabel: 'Invitasjoner',
    invitationPageHeader: 'Invitasjoner',
    createInvitationLabel: 'Skape',
    manageInvitationsLabel: 'Endre',
    createInvitationPageHeader: 'Lag en invitasjon',
    createInvitationPageIntro: 'Skriv meldingen din, legg til og rangér dine inviterte, og lagre mens du går. Trykk på Publiser når du er klar til å sende invitasjonene dine.',
    invitationFormLabelMustMatch: 'Email Must Match',
    invitationFormHelpMustMatch: 'The email of the accepting user must match the email that was invited.',
    invitationFormLabelLabel: 'Invitasjonsetikett',
    invitationFormLabelDescription: 'Navnet på kampanjen din. Dette er kun en referanse for bruk.',
    invitationFormLabelDivision: 'Inndeling',
    invitationFormHelpDivision: 'Divisjonen å invitere noen til. Hvis du setter det tomt, kan den inviterte velge avdelingen.',
    invitationFormHelpDivision2: 'Invitasjoner med ikke tildelte divisjoner har kanskje ikke et registreringsspor forbeholdt seg på grunn av utsalg.',
    invitationFormLabelExpireDays: 'Utløp dager',
    invitationFormHelpExpireDays: 'Antall dager fra e-postmeldingen sendes til invitasjonen utløper. Å sette det tomt betyr at invitasjoner aldri utløper, og alle e-postmeldinger vil bli sendt en invitasjon når de er publisert.',
    invitationCampaignsHeader: 'Invitasjonskampanjer',
    invitationCampaignsLead: 'Opprett og administrer invitasjonskampanjer.',
    invitationCampaignsHelp: 'Klikk på invitasjonen "Etikett" for å få en detaljert oversikt over kampanjestatusen din.',
    invitationDetailHelpText: 'Invitasjonen din er planlagt sendt og begynner å gå ut snart.',
    invitationStopWarning: 'Ved å trykke på denne knappen stoppes denne kampanjen fra å sende flere invitasjoner og avslutter kampanjen permanent.',
    invitationStopHelp: 'Å stoppe denne invitasjonen vil forhindre at flere invitasjoner blir sendt, men vil ikke tilbakekalle invitasjoner som allerede er levert. Er du sikker på at du vil fortsette?',
    invitationPublishConfirmHelp: 'Når du publiserer invitasjonskampanjen, blir den live og starter prosessen med å sende ut invitasjoner. Når du har publisert, vil du ikke kunne redigere e-postadressen din, legge til flere invitasjoner eller omorganisere invitasjonsbestillingen. Er du sikker på at du er klar til å publisere?',
    publishConfirm: 'Ja, publiser',
    inviteOnlyCompRegistrationHelpText: 'Du må motta en invitasjon til å registrere deg for denne konkurransen. Ta kontakt med arrangøren din for mer informasjon.',
    saveDraft: 'Lagre utkast',
    createInvitationDraft: 'Lag invitasjonsutkast',
    compose: 'Komponer',
    invite: 'Invitere',
    saveInviteList: 'Lagre inviterte',
    inviteMessagePreviewLoading: 'Gjengivelsesforhåndsvisning ...',
    invitationsEmailImportLabel: 'Importer e-postadresser',
    invitationsEmailImportHelpText: 'Kopier og lim inn e-postadressene til de du vil invitere (enten en per linje eller komma / mellomrom avgrenset)',
    manageInvites: 'Administrer invitasjoner',
    addInvites: 'Legg til invitasjoner',
    inviteDetailEmail: 'E-post',
    inviteDetailSent: 'Sendt',
    inviteDetailExpires: 'Utløper',
    inviteDetailStatus: 'Status',
    inviteStopCampaign: 'Stopp kampanjen',
    inviteStop: 'Stoppe',
    inviteConfirmStop: 'Ja, stopp',
    inviteDetailDescr: 'Invitasjoner vil bli sendt basert på prioritet, fra toppen av listen. Etter hvert som invitasjoner godtas eller utløper, vil flere bli sendt. Når alle invitasjoner er sendt eller har utløpt, avsluttes kampanjen.',
    inviteDetailExpireDays: 'Invitasjoner utløper <strong>{invitation_expire} dag (er)</strong> fra de sendes.',
    inviteManageLabel: 'Merkelapp',
    inviteManageStatus: 'Status',
    inviteManageTotalInvites: 'Totalt antall invitasjoner',
    inviteManageSent: 'Sendt',
    inviteManageAccepted: 'Akseptert',
    invitationFormLabelMessageHeader: 'Kort melding (valgfritt)',
    invitationFormLabelMessageDescr: 'Vi vil inkludere denne meldingen i den genererte invitasjons-e-posten.',
    inviteStatusExpired: 'Utløpt',
    inviteStatusAccepted: 'Akseptert',
    inviteStatusDeclined: 'Avvist',
    inviteStatusBadEmail: 'Dårlig e-postadresse',
    inviteStatusPending: 'Avventer',
    inviteDefaultMessage: 'Vi inviterer deg gjerne til å registrere deg for {message}!',
    invitationManageSecHeader: 'Dra og slipp for å ombestille inviterte. Invitasjoner blir sendt basert på prioritet fra topp til bunn.',
    invitePublishedTime: 'Publisert kl',
    inviteDeleteInvitee: 'Slett',
    registrationInvites: 'Invitasjoner kreves',
    registrationInviteRequiredHeader: 'Invitasjonskrav',
    registrationInviteRequiredCheckboxMessage: 'Krev invitasjoner for å registrere seg',
    registrationInviteRequiredDescr: 'Hvis valgt, blir registreringen stengt for publikum og kun tilgjengelig via en invitasjon.',
    invitationRequiredToRegister: 'Invitasjon kreves for registrering',
    invalidInviteCodeHeader: 'Invalid Invitation Code',
    invalidInviteCodeText: 'This code has already been used or does not match the intended recipient.',
    publishWarningHeader: 'Konkurransen er upublisert',
    publishWarningDescr: 'Denne funksjonen er ikke tilgjengelig før konkurransen din er publisert.',
    invitationFormNullDivWarning: 'Er du sikker på at du ikke vil tildele en divisjon?',
    invitationFormInviteEmailAddress: 'E-post adresse',
    invitationFormInvitePrevComps: 'Fra tidligere konkurranse',
    invitationRegistrantSelectCompHeader: 'Konkurranse',
    invitationRegistrantSelectCompDescr: 'Velg konkurransen du vil invitere registranter fra',
    invitationRegistrantSelectDivHeader: 'Inndeling',
    invitationRegistrantSelectDivDescr: 'Velg divisjonen du vil invitere registranter fra',
    invitationLoadDivisions: 'Laster inn divisjoner ...',
    invitationLoadRegistrants: 'Laster inn registreringer ...',
    invitationRegSelectorHead: 'Registreringer',
    invitationRegSelectorDescr: 'Registreringer bestilles av <strong>topplasserert plassering i {source_comp}</strong>',
    invitationSelectTop: 'Velg Topp',
    invitationSelectTopDescr: 'Velg alle registranter, eller skriv inn et nummer for å velge de beste X-utøverene som skal legges til i denne kampanjen.',
    invitationNoRegistrants: 'Det er ingen registreringer i denne divisjonen.',
    leaderboardSettingsSubHeader: 'Tilpass leaderboardet ditt ved å justere følgende innstillinger.',
    leaderboardFlagEnabledMessage: 'Når det er slått på, viser landsflagget til atleten. Hvis utøvereikke har satt landet sitt i profilen sin, vises ikke noe flagg.',
    sponsorship: 'Reklame',
    sponsors: 'Sponsorer',
    manageSponsors: 'Administrer sponsorer',
    sponsorsSubHeader: 'Opprett sponsorer, legg til tilknyttede lenker og last opp bildeelementer for bruk i annonsekampanjer.',
    addSponsor: 'Legg til sponsor',
    sponsorName: 'Sponsornavn',
    sponsorNameDescr: 'Det offisielle navnet på sponsoren din.',
    sponsorLink: 'nettsideadresse',
    sponsorLinkDescr: 'Gi en lenke til sponsoren din. Når en tilskuer klikker på sponsorens bilde i annonseplassen, vil de bli sendt til den angitte lenken.',
    sponsorLogo: 'Logo',
    sponsorLogoDescr: 'Last opp en logo for sponsoren din som vises i annonsekampanjer. Vi anbefaler et gjennomsiktig bilde med følgende dimensjoner: {width} x {height}. Et bilde kreves for å opprette en sponsor.',
    sponsorDeleteDescr: 'Sponsoren vil bli fjernet fra eksisterende karuseller eller annonsekampanjer den er tildelt.',
    adCarousels: 'Annonsekaruseller',
    manageAdCarousels: 'Administrer karuseller',
    adCarouselsSubHeader: 'Lag annonsekarusellene dine og fyll dem med sponsormidlene dine. En annonsekarusell er en liste over sponsorlogoer som roterer med jevne mellomrom.',
    addAdCarousel: 'Legg til karusell',
    adCarouselMuteLogosDescr: 'Sponsorlogoer blir dempet.',
    adCarouselName: 'Karusellnavn',
    adCarouselNameDescr: 'Navnet på karusellen',
    adCarouselSponsorsDescr: 'Dra og slipp sponsorer inn i Carousel Staging-området nedenfor. Hvis bestilling er aktivert, vises sponsorer fra topp til bunn.',
    adCarouselStage: 'Karusell Scene',
    adCarouselSponsorsOrderDescr: 'Sponsorer må vises i den angitte rekkefølgen.',
    adCarouselPreview: 'Forhåndsvisning av karusellen',
    adCarouselDeleteDescr: 'Hvis du sletter denne karusellen, slettes også alle annonsekampanjer den er tildelt.',
    adCampaigns: 'Annonsekampanjer',
    manageAdCampaigns: 'Administrer annonsekampanjer',
    adCampaignsSubHeader: 'Opprett annonsekampanjer, tilordne annonsekarusellene, velg hvilke offentlige sider annonsekarusellene dine skal vises på, og konfigurer tidspunktene de skal vises på.',
    addAdCampaign: 'Legg til kampanje',
    adCampaignName: 'Kampanjenavn',
    adCampaignNameDescr: 'Oppgi et navn på kampanjen',
    adCampaignCarousel: 'Karusell',
    adCampaignCarouselDescr: 'Velg karusellen som skal brukes til denne kampanjen',
    adCampaignPages: 'Sider',
    adCampaignAddAllPages: 'Legg til på alle tilgjengelige sider',
    adCampaignPagePreview: 'Forhåndsvisning',
    adCampaignPagesDescr: 'Velg alle tilgjengelige sider, eller velg spesifikke deler av hver side',
    adCampaignDates: 'Datoer',
    adCampaignDatesDescr: 'Velg en dato og et tidspunkt for å starte kampanjen og avslutte den. Karusellen vises bare på de valgte sidene hvis gjeldende dato og klokkeslett er innenfor dette datoperioden.',
    adCampaignConflictingCampaigns: 'Motstridende kampanjer',
    adCampaignConflictingCampaignsWarning: 'Du kan ikke lagre denne kampanjen fordi den kommer i konflikt med følgende kampanjer:',
    adCampaignConflictingPagesWarning: 'Disse kampanjene deler følgende sidekampanjeseksjoner i en overlappende tidsperiode:',
    adCampaignNoCarousels: 'Det er ingen annonsekaruseller tilgjengelig. Opprett en ved hjelp av siden <a href="/app/competitions/{competitionId}/setup/marketing/ad-carousels/">Annonsekaruseller</a> .',
    adCampaignsReport: 'Annonserapport',
    filter: 'Filter',
    adCampaignsFilterDescr: 'Filtrer etter kampanje, karusell eller sideseksjon',
    carousel: 'Karusell',
    pageSlots: 'Sideseksjoner',
    selectCampaign: 'Velg en kampanje ...',
    selectCarousel: 'Velg en karusell ...',
    selectPageSection: 'Velg en sideseksjon ...',
    ticketLinks: 'Billettkoblinger',
    ticketer: 'Ticketer',
    pageNotFound: 'Den siden ble ikke funnet.',
    pleaseCheckLinkAgain: 'Vennligst sjekk lenken til denne siden igjen og kontroller at den er riktig.',
    noPermission: 'Du har ikke tillatelse til å se dette.',
    publishHeatAssignments: 'Publiser varmeoppgaver',
    areYouSurePublishHeatAssignments: 'Er du sikker?',
    heatAssignmentPublishWarning: 'Etter publisering vil utøvere se oppgavene på sin personlige timeplan.',
    unpublishHeatAssignments: 'Fjern publisering av varmeoppgaver',
    areYouSureUnpublishHeatAssignments: 'Er du sikker?',
    unpublishHeatAssignmentsWarningIntro: 'Dette fjerner varmeoppdrag fra offentlig visning av tidsplaner',
    unpublishHeatAssignmentsWarningBody: '',
    confirmUnpublishHeatAssignments: 'Ja, opphev oppgavene',
    ticketing: 'Billettsalg',
    spectators: 'Tilskuere',
    manageAssignmentsInfo: 'Utvid segmentene dine for å få tilgang til manuelt å velge varme / kjørefelt for hver utøvere',
    competitionLandingDefaultDescr: '<h1><span style="color: rgb(36, 41, 46);">Velkommen til {competitionName}!</span></h1><p><br></p><p> <span style="color: rgb(36, 41, 46);">Vi er glade for at du vil delta på arrangementet vårt. Informasjon om konkurransedato, treningsøkter og divisjoner finner du på landingssiden vår. Herfra kan du også registrere deg, se leaderboards, kjøpe billetter og mer!</span></p><p><br></p><p> <span style="color: rgb(36, 41, 46);">Hvis du har spørsmål, kan du kontakte <a href="mailto:{competitionEmail}">{competitionEmail}</a> for å få hjelp.</span></p>',
    hashtagsPlaceholder: 'Legg til hashtag ...',
    defaultHashtags: 'Foreslåtte Hashtags',
    hashtags: 'Hashtags',
    hashtagsLabel: 'Custom Leaderboard League',
    organizerHashtagExplanation: 'Utøvere kan bruke hashtags for å konkurrere med mindre grupper på et tilpasset leaderboard.<br/> Skriv inn en liste med hashtags som vil bli foreslått til utøverene dine ved registrering.',
    myHashtagsDescr: 'Lag søkbare hashtags for å konkurrere med ligaen eller vennene dine på ditt eget tilpassede toppliste (#ArmyStrong, #NYC, #FitLife, etc.)',
    advancedFilters: 'Søk / filtrer denne divisjonen',
    applyFilters: 'Bruk filtre',
    clearFilters: 'Fjern filtre',
    birthdateLabel: 'Fødselsdato',
    selectMonthYearLabel: 'Velg først en måned og et år',
    selectDayLabel: 'Velg dag',
    selectMonthLabel: 'Velg måned',
    selectYearLabel: 'Velg år',
    january: 'januar',
    february: 'februar',
    march: 'mars',
    april: 'april',
    may: 'mai',
    june: 'juni',
    july: 'juli',
    august: 'august',
    september: 'september',
    october: 'oktober',
    november: 'november',
    december: 'desember',
    noMatchingAthletes: 'Det er ingen utøvere som samsvarer med de angitte filtrene.',
    filterEntriesFound: 'utøvere funnet på dette topplisten.',
    canFilterLeaderboardLabel: 'Brukes som Leaderboard Filter',
    canFilterLeaderboardDescr: 'Dette spørsmålet kan brukes til å filtrere ledertavler ned til mindre grupper av utøvere.',
    iJustRegistered: `Jeg registrerte meg akkurat for {compName} på ${SHORT_DOMAIN}!`,
    shareYourRegistration: 'Last ned og del dette bildet for å fortelle vennene dine at du har registrert deg!',
    iJustScored: `Jeg logget nettopp på {score} for {workout}. Sjekk ledertavlene for {compName} på ${SHORT_DOMAIN}!`,
    shareYourScore: 'Last ned dette bildet og del registreringen din med vennene dine!',
    howToFilterModalTitle: 'Visste du?',
    howToFilterModalBody: 'Du kan søke etter en utøvereeller opprette et leaderboard med bare deg og vennene dine ved å klikke "Søk og filtrer".',
    howToFilterModalButton: 'Har det!',
    howToShareModalTitle: 'Del ditt tilpassede brett',
    howToShareModalBody: 'Deling av dette tilpassede topplisten er like enkelt som å kopiere og lime inn nettadressen!',
    howToShareModalButton: 'Har det!',
    leaderboardAutoPublishTurnedOn: 'Auto-publisering på leaderboard er slått PÅ. <a href="/app/competitions/{competitionId}/leaderboards/settings/">Oppdater innstillinger</a>',
    leaderboardAutoPublishTurnedOff: 'Auto-publisering på leaderboard er slått AV. <a href="/app/competitions/{competitionId}/leaderboards/settings/">Oppdater innstillinger</a>',
    trials: {
      oneDayTrial: 'Prøv det gratis nå!',
      yourTrialExpired: 'Prøveperioden din er utløpt',
      nocc: 'Ingen kredittkort kreves',
      activate: 'Aktiver!',
      weSentARequest: 'Vi har sendt en forespørsel til kontorepresentanten din om å aktivere denne funksjonen. De vil ta kontakt om kort tid!',
      sponsorship: {
        img: 'https://strongest.com/wp-content/uploads/2020/03/throwdowns-marketing-1024x525.png',
        icon: 'rectangle-ad',
        title: 'Sponsing Kit',
        description: 'Lås opp unike logo-plasseringer for sponsorene dine og deres merker! Dette settet lar deg lage tilpasset sponsinginnhold på nøkkelsider for å øke inntektene og holde sponsorene lykkelige.',
        features: [{'icon':'conveyor-belt-boxes','copy':'Lag roterende sponsorlogoer på dine mest viste konkurransesider.'},{'icon':'chart-line','copy':'Sikre sponsorverdi med tilpassbare nettadresser på logoer for å spore sidevisninger og klikkfrekvenser.'},{'icon':'dollar-sign','copy':'Øk inntektene for konkurrentene dine ved å trekke inn nye sponsorer!'}]
      },
      scheduling: {
        img: 'https://strongest.com/wp-content/uploads/2020/03/throwdowns-scheduling-1024x587.jpg',
        icon: 'stopwatch',
        title: 'Planleggingssett',
        description: 'Heat-Planlegger er ofte et siste øyeblikk “gotcha” som arrangørene tenker på altfor sent. Med dette settet kan du lage og publisere timeplanen din slik at alle får vite hva / hvor / når for hvert øyeblikk av konkurransen. Dine utøvere, fans, frivillige og ansatte vil takke deg.',
        features: [{'icon':'clock','copy':'Lag tidsplaner som er sømløst integrert med våre registrerings- og poengsumssystemer.'},{'icon':'table','copy':'Beregn og administrer tidsplaner i appen - Ingen separate regneark!'},{'icon':'users','copy':'"Reseed" utøvere dine smertefritt med vår spesialbygde planlegger.'}]
      },
      liveScoring: {
        img: 'https://strongest.com/wp-content/uploads/2020/05/throwdowns-scoring-broadcasting.png',
        icon: 'table-list',
        title: 'Live Scoring Kit',
        description: 'Utnytt verktøyene som er nødvendige for å trekke seere fra hele verden til konkurrentene dine. Med dette settet kan du spore og vise resultatene når de skjer i sanntid: ingen ventetid på at varmen er ferdig! Gi kommentatorer mulighet til å fortelle OG vise en flott historie med relevante datadrevne, live action-resultater på skjermen.',
        features: [{'icon':'award','copy':'Oppdater Leaderboards kontinuerlig for hver heat i sanntid.'},{'icon':'tv','copy':'Bruk datadrevet grafikk og legg ut resultater på klokkeskjerm, mobile enheter eller skjermbånd.'},{'icon':'dollar-sign','copy':'Maksimer inntektene fra billetter, online seere og sponsorer.'}]
      },
      precisionTiming: {
        img: 'https://strongest.com/wp-content/uploads/2020/05/throwdowns-precision-timing.png',
        description: 'La utøverene dine bli sterke med en ettertrykkelig handling som ikke bare underholder, men som gir nøyaktighet. Vårt presisjonstidsett inkluderer knappene, samt toppmoderne integrasjon med chip timere for å sikre at du kjører en førsteklasses hendelse med en timing nøyaktig til 1/100 sekundet. Ikke flere tvister om menneskelige feil, ikke mer gjetting: bare tiltalende, spektakulære finish.',
        title: 'Presisjonstidssett',
        features: [{'icon':'stopwatch','copy':'Sikre nøyaktighet uten risiko for menneskelig tidsfeil.'},{'icon':'trophy','copy':'Lag spennende, høydepunktverdige avslutninger ved å trykke på en knapp eller krysse en mållinje drevet av timingchips.'},{'icon':'award','copy':'Se profesjonell ut med automatisk, teknologidrevet resultatsporing.'}]
      },
      broadcasting: {
        img: 'https://strongest.com/wp-content/uploads/2020/05/throwdowns-scoring-broadcasting.png',
        icon: 'tv',
        title: 'Broadcast Kit',
        description: 'Broadcasting Kit leverer grafikk av nettverkskvalitet som lenker sømløst med datastrømmer fra våre informasjonssystemer for live score og kommentator. Hvert sekund som går er verdifullt under en live produksjon, så vi har optimalisert programvaren og arbeidsflytene, slik at du kan hente produksjon av høyeste kvalitet med en brøkdel av den typiske innsatsen som kreves.'
      }
    },
    siteContent: {
      topLevelHelp: '<div class="content"><h2>Velkommen</h2><p><br></p><p> Når du samhandler med konkurranser, vil du merke en <strong>?</strong> hjelpeikon (akkurat som det som er valgt til menyen til venstre) som gir målrettet kontekstuell hjelp for hvordan hver del av appen fungerer.</p></div>',
      compSetupMarketing: '<div class="content"><h1>Markedsføring</h1><p> Under <strong>markedsfanen</strong> kan du tilpasse nesten alle de viktigste markedsføringsaspektene i konkurransen.</p><ul><li> <strong>Oppsett-</strong> fanen inneholder all informasjon på høyt nivå om konkurransen, for eksempel navn, webadresse, kontaktinformasjon og forsidebilde.</li><li> <strong>Innhold-</strong> fanen er der du kan redigere innholdet på destinasjonssiden. Dette er den første siden brukerne vil se når de kommer til konkurransen din, og den primære siden du vil dele på sosiale medier for å markedsføre konkurransen.</li><li> <strong>Tid og sted-</strong> fanen er der du kan angi sted og sted for live-konkurranser. Du kan også angi den offisielle datoen og tidssonen for konkurransen fra denne menyen.</li><li> Hvis konkurransen din tillater utøvere å sende inn sine egne score, vil du kunne konfigurere innstillingene for resultatregistrering av poengsummer under kategorien <strong>Online Scoring</strong> .</li></ul><p> Ta en titt på <a href="http://help.strongest.com/en/">brukerstøtten</a> for flere supportartikler om markedsføring av arrangementet ditt.</p></div>',
      compSetupProgramming: '<div class="content"><h1>Programmering</h1><p> Under <strong>underfanen Programmering</strong> kan du tilpasse alle aspekter av konkurransens divisjoner, treningsøkt og poengpolitikk.</p><ul><li> Kategoriene <strong>Divisjoner</strong> og <strong>treningsøkter</strong> lar deg administrere alle de forskjellige innstillingene for divisjonene og treningsøktene dine.<ul><li> Innenfor hver klasse / treningsøkt kan du legge til / fjerne oppføringer, legge inn innhold (inkludert bilder og videoer) og angi avanserte detaljer som registreringsgrenser per klasse, totalt antall teammedlemmer eller utgivelsestider for test.</li><li> Vi anbefaler at du inkluderer klare bevegelsesstandarder for hver treningsøkt og en kort beskrivelse for hver klasse.</li></ul></li><li> <strong>Poengpolicyer-</strong> fanen er der du kan angi spesifikke regler for hvordan registreringen beregnes.</li><ul><li> <strong>Poengtypen</strong> påvirker alle divisjoner og treningsøkter, og bestemmer den generelle utøverplasseringen på ledertavlen. Vi anbefaler å bruke enten plasseringsbasert resultat eller standard CrossFit® Games poengtabeller. Du kan lære mer om disse poengtypene i <a href=http://help.strongest.com/en/articles/3062621-choosing-your-scoring-policies>denne hjelpeartikkelen</a> .</li><li> For treningsøkter vil du enten angi at en høyere poengsumverdi er bedre (f.eks. AMRAP, maks. Innsatsløft osv.) Eller at en lavere poengsumverdi er bedre (tidsbaserte treningsøkter.) Du kan angi retningslinjer for uavgjort, repteller, og tidsbegrensninger her også.</li></ul></ul><p> Husk: nøkkelen til god programmering er enkelhet. Jo lettere det er for utøvere å forstå standardene og hvordan scoring fungerer, jo bedre!</p><p> Ta en titt på <a href="http://help.strongest.com/en/">brukerstøtten</a> for flere supportartikler om hvordan du oppretter konkurranseprogrammering eller konfigurerer registreringen.</p></div>',
      compSetupRegistration: '<div class="content"><h1>Registrering</h1><p> Under <strong>Registrering-</strong> underfaner kan du tilpasse hele registreringsopplevelsen for utøvere og frivillige.</p><ul><li> <strong>Innhold-</strong> fanen er der du kan tilpasse innholdet som brukeren vil se når de kommer til registreringssiden din. Du kan legge inn tekst, samt legge inn bilder og video.</li><li> I <strong>kategorien Gebyrer</strong> kan du spesifisere billettpriser og valutaen som skal brukes ved utøveren.</li><li> Kategorien <strong>Detaljhandel</strong> er der du kan opprette og administrere flere varer som skal tilbys ved registrering. Du kan angi navn, pris og mengde på varene.</li><li> Kategorien <strong>Datoer</strong> er der du kan konfigurere åpning / lukking av datoer og klokkeslett for registrering. Husk at innstillingene for tidssone gjelder her. Du kan endre dem under markedsføringsmenyen etter behov.</li><li> <strong>Innskudd-</strong> fanen viser Stripe-kontoen konkurransen er koblet til. Stripe-kontoen din er der du vil motta innskudd når utøverene dine registrerer deg.</li></ul><p> Ta en titt på <a href="http://help.strongest.com/en/">brukerstøtten</a> for flere supportartikler for å tilpasse registreringen og administrere registrantene</p></div>',
      compSetupAdvanced: '<div class="content"><h1>Avanserte innstillinger</h1><p> <strong>Avanserte</strong> underfaner inneholder flere ekstra funksjoner som kan brukes til å tilpasse konkurranseopplevelsen ytterligere, spesielt ved registrering.</p><ul><li> Hvis du vil tilby kuponger til utøverne dine, kan du gjøre det under fanen <strong>Kuponger</strong> . Du kan lage kuponger med en rekke begrensninger, for eksempel faste eller prosentbaserte beløp av billettprisen, utløpsdatoer, begrenset antall kuponger osv.</li><li> <strong>Custom</strong> kategorien <strong>Waiver</strong> kan du lage en tilpasset waiver for registrering. Vi har gitt noe standardfraskrivelsesinnhold, men vi anbefaler alltid at du går gjennom det nøye og bruker ditt eget avtale hvis du har et som allerede er gjennomgått av ditt juridiske team.</li><li> Du kan legge til <strong>egendefinerte felt</strong> i registreringsskjemaet ditt hvis det er tilleggsinformasjon du vil fange fra utøvere. For eksempel vil noen arrangører spørre utøvere hvordan de hørte om konkurransen, eller spør om en utøvereer en førstegangskonkurrent. Denne informasjonen kan senere hentes gjennom eksportfunksjonen i <strong>Registrants-</strong> fanen.</li><li> Det er høyst usannsynlig at du må gjøre endringer i undermenyen <strong>Advanced Scoring Policies.</strong> Hvis du føler at konkurransen din har spesielle poengbehov som standardinnstillingene i Programmering-fanen ikke dekket, kan du kontakte oss, så hjelper vi deg gjerne med avansert konfigurasjon.</li><li> <strong>Registreringshetten</strong> er der du kan sette et globalt tak på antall utøvere som er tillatt for konkurransen din.</li><li> <strong>Registreringstilgang</strong> avgjør om registrantene dine har muligheten til å oppdatere registreringen fra dashbordet. Dette er aktivert som standard. Hvis funksjonshemmede, vil ikke utøvere kunne oppdatere registreringen etter at de har betalt.</li><li> Bytting av <strong>påkrevde invitasjoner</strong> vil låse registreringen og kreve at registranter har en invitasjon for å kunne registrere seg. Invitasjoner sendes gjennom fanen <strong>Invitasjoner</strong> .</li></ul><p> Ta en titt på <a href="http://help.strongest.com/en/">brukerstøtten</a> for flere supportartikler om disse avanserte funksjonene.</p></div>',
      compRegistrants: '<div class="content"><h1>Registranter</h1><p> Underfanen <strong>Registranter</strong> inneholder enkle rapporter som viser hvem som har registrert seg for konkurransen din etter klasse.</p><p> Det er også et par andre funksjoner:</p><ul><li> Du kan se utøvernavn, e-post, registreringsdato og registreringsgebyrer.</li><li> Du kan redigere navnet på en utøvereog endre klasse.</li><li> Du kan eksportere registreringsdata på tvers av alle divisjoner.</li></ul><p> <strong>Forespørselen om eksporteksputt</strong> øverst til høyre på siden lar deg ta en &quot;øyeblikksbilde&quot; -eksport av alle dine idrettsutøvelsesregistreringsdata. Når den er klar, sender appen deg en e-post som inneholder en csv-fil med alle registrantene dine for enkel lagring og analyse.</p></div>',
      compScoring: '<div class="content"><h1>Resultatoppføring og gjennomgang</h1><p><br></p><ul><li> <strong style="background-color: transparent;"><span style="background-color: transparent;">Stillingen</span> Entry</strong> <span style="background-color: transparent;">underfaner er der du vil administrere score for hver av divisjonene.</span></li><li> <span style="background-color: transparent;">Du kan bruke koblingen</span> <strong style="background-color: transparent;">Dataregistreringskoblinger</strong> <span style="background-color: transparent;">til å opprette og dele lenker for &quot;kiosk score entry&quot; med personer som du vil tilordne som delegater. Vanligvis vil disse personene være medlemmer av personalet ditt som skriver inn poeng når papirkort kommer til registreringen.</span></li><li> <span style="background-color: transparent;">Under hver divisjons underfane kan du skrive inn resultat og forhåndsvise hvordan poengoversikten vil se ut når poengene blir publisert. Imidlertid vil de offisielle offentlige leaderboards ikke oppdateres før du publiserer leaderboards.</span></li><li> <span style="background-color: transparent;">Mange konkurranser foretrekker å la MC gjøre en &quot;stor avsløring&quot; på slutten av konkurransen like før prisutdelingen, og muligheten til å forhåndsvise et leaderboard før publisering kan være nyttig her.</span></li><li> <span style="background-color: transparent;">Manuelt angitte utøvere kan fjernes fra poengsumtabellen ved å slette navnet deres fullstendig. Dette fjerner også alle poeng som er lagt inn i oppføringen.</span></li><li> <span style="background-color: transparent;">Hvis konkurransen din involverer resultat på nettet, vil du kunne gjennomgå (godkjenne / avvise) alle poeng som sendes inn av utøvere med poenganmeldelsesverktøyene som er under delmenyene på divisjonsnivå.</span></li><li> <span style="background-color: transparent;">Resultatregistrering av scoringer på nettet som er godkjent, oppdateres automatisk til det offentlige topplisten etter en viss tid (hvert 5. minutt eller så).</span></li></ul><p><br></p></div>',
      compSupport: '<div class="content"><h1>Brukerstøtte</h1><p><br></p><p> <span style="background-color: transparent;">Alle menyene er organisert i seksjoner:</span> <strong style="background-color: transparent;">Oppsett</strong> <span style="background-color: transparent;">,</span> <strong style="background-color: transparent;">Administrasjon</strong> <span style="background-color: transparent;">,</span><strong style="background-color: transparent;"> </strong><span style="background-color: transparent;">og</span> <strong style="background-color: transparent;">støtte</strong></p><ul><li> <span style="background-color: transparent;">Hver kategori under</span> <strong style="background-color: transparent;">Oppsett-</strong> <span style="background-color: transparent;">delen lar deg endre innstillinger som du har konfigurert under den guidede trinnvise prosessen. Når du har konfigurert disse innstillingene riktig, trenger du sannsynligvis ikke å gå tilbake og samhandle med dem når konkurransen din har blitt lansert.</span></li><li> <span style="background-color: transparent;">Hver fane under</span> <strong style="background-color: transparent;">Management-</strong> <span style="background-color: transparent;">delen involverer daglige operasjoner for konkurransen din.</span></li><li class="ql-indent-1"> <span style="background-color: transparent; color: rgb(33, 35, 41);">For eksempel vil du sannsynligvis holde øye med registreringer under</span> <strong style="background-color: transparent; color: rgb(33, 35, 41);">Registrants-</strong> <span style="background-color: transparent; color: rgb(33, 35, 41);">fanen når registreringene fylles opp.</span></li><li class="ql-indent-1"> <span style="background-color: transparent; color: rgb(33, 35, 41);">For online hendelser, vil du også være å bruke ordinær tid under <span style="background-color: transparent; color: rgb(33, 35, 41);">fanen</span></span> <strong style="background-color: transparent; color: rgb(33, 35, 41);">Score Entry</strong> <span style="background-color: transparent; color: rgb(33, 35, 41);">en anmeldelse score som test vinduer lukkes.</span></li><li class="ql-indent-1"> <span style="background-color: transparent; color: rgb(33, 35, 41);">For live-arrangementer på stedet vil scoringsbordet ditt skrive inn poeng under kategorien</span> <strong style="background-color: transparent; color: rgb(33, 35, 41);">Poengoppføring</strong> <span style="background-color: transparent; color: rgb(33, 35, 41);">gjennom hele konkurransen.</span></li><li> <span style="background-color: transparent;"><span style="background-color: transparent;"><strong style="background-color: transparent;">Support-delen</strong></span> vil være der vi fortsette å skape og tilby unik støtte funksjoner for å bedre hjelpe kjøre konkurrentene dine!</span></li><li class="ql-indent-1"> <span style="background-color: transparent;">Husk at du alltid kan nå oss direkte gjennom Intercom, det lille, svarte tekstikonet nederst til høyre på skjermen.</span></li></ul><h2> Hurtigstartvideo</h2><p><br></p><p> Her er en kort ~ 2,5 minutters video vi opprettet som gir deg en rask orientering om hvordan systemet fungerer. </p><p><br></p><iframe class="ql-video" frameborder="0" allowfullscreen="true" src="https://www.youtube.com/embed/yaTL8CPR21s?showinfo=0"></iframe><p><br></p><p><br></p></div>',
      compSetupHeatScheduling: `<div class="content"><h1>Heat-Planlegger</h1><p><br> <strong>Velkommen til hjelpesiden for å lage heat-planer!</strong></p><p> Vi vet at å lage en tidsplan fra bunnen av kan være en vanskelig og tidkrevende oppgave. Derfor bygde vi et intuitivt, brukervennlig verktøy for å hjelpe deg med å lage, administrere og dele heat-planen din innen ${APP_NAME} økosystemet.</p><p> For å begynne å lage timeplanen din, ber vi deg først gå gjennom installasjonsveiviseren. Dette formatet gjør det lettere å bryte ned og arbeide gjennom de forskjellige delene av å lage en tidsplan.</p><p> Vi anbefaler på det sterkeste at du også sjekker ut vårt brukerstøtte for en fullstendig guide om alt du trenger å vite om planleggeren vår. Hjelpeartiklene er designet for ikke bare å hjelpe deg gjennom de tekniske delene av å lage timeplanen din, men også for å styrke de beste metodene og mønstrene som brukes av profesjonelle konkurranser over hele verden.</p><p> Hvis du noen gang har spørsmål eller trenger hjelp til å sette opp timeplanen din, ikke nøl med å kontakte oss!</p></div>`,
      compInvitations: '<div class="content"><h1>Invitasjoner</h1><p> <strong>Velkommen til hjelpesiden for invitasjoner!</strong></p> Gjennom Invitations-fanen kan du sende invitasjoner til utøvere, frivillige og tilskuere via e-post, slik at de kan registrere seg for arrangementet ditt.<p><p> Noen av funksjonene inkluderer:</p><ul><li> Evne til å justere meldinger i invitasjonen din</li><li> Dynamisk invitasjonssystem som sender invitasjoner i den spesifikke rekkefølgen du angir</li><li> Funksjonalitet for å invitere brukere til spesifikke divisjoner.</li><li> Spore beregninger slik at du vet om en invitasjon er akseptert, utløpt, eller om e-postadressen som er oppgitt er ugyldig.</li></ul><p> Ta en titt på <a href="http://help.strongest.com/en/">brukerstøtten</a> vår for spesifikke støtteartikler angående invitasjoner.</div>',
      compLeaderboards: '<div class="content"><h1>Leaderboard Display Preferences</h1><p> <strong>Velkommen til hjelpesiden for Leaderboard Display Preferences!</strong></p> Denne funksjonen lar deg konfigurere de forskjellige skjerminnstillingene du vil ha for leaderboards.<p><p> Noen av de nåværende og kommende skjerminnstillingene for leaderboards er:</p><ul><li> Evne til å vise landsflaggene til registranter</li><li> (Kommer snart!) Evne til å vise tilknyttede navn på registranter</li><li> (Kommer snart!) Evne til å bytte videolink til innsending av resultat for å vises på poengoversikten</li><li> Og mer!</li></ul><p> Når vi fortsetter å bygge ut konfigurasjonsinnstillinger, vil de vises her.</p><p> Hvis du prøver å forhåndsvise eller publisere leaderboards, vil du gjøre det fra kategorien <strong>Poengoppføring</strong> , ikke fra denne kategorien.<p> Ta en titt på <a href="http://help.strongest.com/en/">brukerstøtten</a> for supportartikler som gir eksempler på våre forskjellige leaderboard-visningsalternativer.</div>',
      compSetupTicketing: '<div class="content"><h1>Billettsalg</h1><p> <strong>Velkommen til hjelpesiden for å lage billetter til ditt arrangement!</strong></p> Denne funksjonen lar deg lage, redigere og administrere de forskjellige billettene du vil tilby dine tilskuere.<p><p> Det er tre hovedfaner:</p><ul><li> <strong>Innhold-</strong> fanen lar deg tilpasse teksten som vises øverst på siden for billettkjøp.</li><li> Kategorien <strong>Datoer</strong> er der du vil angi startdatoen for når billetter blir solgt, og sluttdatoen for når billetter ikke lenger er tilgjengelige for kjøp.</li><li> <strong>Fanen Billetter</strong> er der du oppretter, redigerer og sletter billettalternativene. I denne kategorien kan du konfigurere pris, antall, navn og beskrivelse av de forskjellige billettene dine.</li></ul><p> Hver billett som selges kommer med en unik QR-kode som sendes til kjøperen både i appen og via e-post. Denne QR-koden gjør det enkelt for deg å validere billetter til innreise under live-arrangementet ditt.</p><p> Når billettene dine er kjøpt, vil tilskuerne og billettene deres bli fylt ut i kategorien <strong>Tilskuere på</strong> toppnivå.</p><p> Ta en titt på <a href="http://help.strongest.com/en/">brukerstøtten</a> for spesifikke supportartikler angående billetter.</p></div>',
      compSpectators: '<div class="content"><h1>Tilskuere</h1><p> <strong>Velkommen til hjelpesiden for å administrere dine tilskuere!</strong></p> <strong>Underfanen Spectators</strong> inneholder en enkel rapport om de forskjellige billettene som er kjøpt til arrangementet ditt.<p><p> Fra denne fanen kan du:</p><ul><li> Vis grunnleggende kontaktinformasjon for billettholdere, for eksempel navn og e-post.</li><li> Se hvilken billett du har kjøpt, dens unike ID, samt den nåværende innløsningsstatusen.</li><li> Filtrer resultatene etter navn, e-post eller billett-ID.</li></ul><p> Hver billett som selges kommer med en unik QR-kode som sendes til kjøperen både i appen og via e-post. Denne QR-koden gjør det enkelt for deg å validere billetter til innreise under live-arrangementet ditt.</p><p> Ta en titt på <a href="http://help.strongest.com/en/">brukerstøtten</a> vår for spesifikke supportartikler angående tilskuerbilletter.</p></div>'
    },
    setADateRange: 'Angi et datoområde',
    clearDateRange: 'Fjern datointervall',
    selectAll: 'Velg alle',
    selectNone: 'Velg ingen',
    close: 'Lukk',
    issueLoadingPaymentForm: 'Det oppsto et problem ved innlasting av betalingsskjemaet. Vennligst oppdater.',
    uploading: 'Laster opp ...',
    imageTooBig: 'Det bildet er for stort. Grensen er 5 MB.',
    uploadImage: 'Last opp et bilde',
    clearImage: 'Tydelig bilde',
    youtubeEmbed: 'YouTube Bygg inn',
    addVideo: 'Legg til video',
    loadingCompetition: 'Laster konkurranse',
    draft: 'Utkast',
    readyToPublish: 'Er du klar til å publisere konkurransen?',
    yesPublish: 'Ja, publiser!',
    pleaseEnterAValidEmail: 'Vennligst skriv inn en gyldig e-post adresse.',
    competition: 'Konkurranse',
    id: 'ID',
    youllBeNotifiedWhenYourExportIsReady: 'Du får beskjed om kort tid via e-post når eksporten er klar.',
    deleted: 'Slettet',
    noVideo: 'Ingen video',
    url: 'URL',
    youtubeUrlDesc: 'URL-en til YouTube-videoen',
    image: 'Bilde',
    scoreRejection: 'Poengavvisning',
    scoreRejectionDesc: 'Du avviser en resultat sendt av en utøvere. Dette vil skjule registreringen på poenglisten, som om ingen resultat ble sendt inn.',
    rejectReason: 'Avvis grunn',
    rejectReasonDesc: 'Legg igjen en kommentar som forklarer hvorfor registreringen ble avvist. Dette vil hjelpe utøveren til å forstå hvorfor deres resultat ble avvist',
    rejectAndEmailAthlete: 'Avvis og send utøverevia e-post',
    unreject: 'Avvis',
    reject: 'Avvis',
    unverify: 'Fjern bekreftelse',
    verify: 'Bekrefte',
    evidence: 'Bevis',
    noEvidence: 'Ingen bevis',
    showingTopOneHundredAthletes: 'Viser de 100 beste utøverne. Bruk søk for å finne en hvilken som helst utøverefor å angi / endre registreringen.',
    nameOrBibNumber: 'Navn eller Bib-nummer',
    spectatorFilterDesc: 'Filtrer på navn, e-post eller billett-ID',
    acceptRegistrationWaiver: 'Godta registreringsfraskrivelse',
    appWaiver: `${APP_NAME} avtale`,
    compWaiver: 'Konkurranseavkall',
    yesIAgreeToBoth: 'Ja, jeg er enig i begge deler',
    searching: 'Søker...',
    stoppedAt: 'Stoppet kl',
    seeMore: 'Se mer',
    groupLeaderboards: 'Gruppelederbord',
    groupLeaderboardsDesc: 'Lag kombinerte ledertavler ved å samle utøvere i bestemte divisjoner.',
    divisionsMustHaveSameWorkouts: 'De valgte divisjonene må ha samme treningsøkt',
    showCountryFlag: 'Vis landsflagg',
    enableAutoPublish: 'Aktiver automatisk publisering',
    autopublishDesc: 'Når dette er aktivert, blir leaderboard automatisk publisert hvis det er noen endringer, minst hvert 10. minutt.',
    showVideoOrImage: 'Vis video / bildekoblinger',
    showVideoOrImageDesc: 'Når dette er slått på, vises video- / bildekoblinger på poengoversikten for alle poeng som har en video- eller bildesending. Ellers kan videoer eller bilder bare vises av arrangørpersonalet i poengsumtabellen.',
    discountedSubtotal: 'Rabatt delsum',
    teamMembersCantShareEmails: 'Teammedlemmer kan ikke dele e-postadresser, ettersom hvert medlem må logge på og signere et avtale.',
    needsToSignWaiver: 'Må signere avtale',
    time: 'Tid',
    unpublishing: 'Avpubliserer ...',
    noScore: 'Ingen resultat',
    typeAthleteAutosuggest: 'Skriv ut idrettsnavn for automatisk fullføring av valg for å få tilgang til poengkortene.',
    capIsGreaterThanDivisionCaps: 'Selv om dette taket er gyldig, er verdien større enn summen av alle delingshetter, og det vil derfor aldri ha noen synlig effekt.',
    schedulePreview: 'Planlegg forhåndsvisning',
    thisRegeneratesAllHeatsWarning: 'Dette vil gjenskape varme for dette valget fullstendig og miste eventuelle manuelle redigeringer du har gjort. Er du sikker?',
    yesRegenerateAllHeats: 'Ja, regenerer varmer',
    regenerateAllHeats: 'Regenerer varmer',
    generateHeats: 'Generer varme',
    filterDivisionsDesc: 'Velg en inndeling å filtrere etter',
    allDivisions: 'Alle divisjoner',
    filterWorkoutsDesc: 'Velg en treningsøkt du vil filtrere etter',
    allWorkouts: 'Alle treningsøkter',
    editHeat: 'Rediger Heat',
    heatTitleDesc: 'Tittel på varmen for tidsplanvisning',
    startTime: 'Starttid',
    pickAStartTime: 'Velg starttid',
    endTime: 'Sluttid',
    pickAnEndTime: 'Velg sluttid',
    moving: 'Flytter ...',
    moveHeats: 'Flytt 1 varme hit | Flytt {n} Varm hit',
    doneEditing: 'Ferdig å redigere',
    recalculateAssignments: 'Beregn oppgavene på nytt',
    updateFromLeaderboard: 'Oppdatering fra Leaderboard',
    noScoresPublished: 'Ingen poeng publisert',
    regenerateHeats: 'Regenerer varme',
    updateManually: 'Oppdater manuelt',
    seeding: 'Såing',
    reset: 'Nullstille',
    saved: 'Lagret',
    clear: 'Klar',
    addJudge: 'Legg til dommer',
    emptyLane: 'Tom kjørefelt',
    swapping: 'Bytting...',
    cancelSwap: 'Avbryt bytt',
    swap: 'Bytte',
    addBack: 'Legg tilbake',
    addingBack: 'Legger til Tilbake ...',
    removing: 'Fjerner ...',
    yesRemove: 'Ja, fjern',
    remove: 'Fjerne',
    hasMultipleRegistrations: 'har flere registreringer',
    working: 'Jobber...',
    yesClearTodaysSchedule: 'Ja, fjern dagens tidsplan',
    youMustHaveAtLeastOneWorkoutLocation: 'Du må ha minst ett treningssted.',
    youMustHaveAtLeastOneDay: 'Du må ha minst en dag.',
    addDay: 'Legg til dag',
    locationSchedule: 'Plasseringsplan',
    viewScheduleByLocation: 'Se tidsplanen etter sted',
    viewScheduleByDay: 'View by Day',
    hideContent: 'Skjul innhold',
    showContent: 'Vis innhold',
    deleteEvent: 'Slett hendelse',
    areYouSureYouWantToDeleteThisEvent: 'Er du sikker på at du vil slette denne hendelsen?',
    editEvent: 'Rediger hendelse',
    moveToDifferentDay: 'Gå til en annen dag',
    day: 'Dag',
    moveToDifferentLocation: 'Flytt til et annet sted',
    move: 'Bevege seg',
    customize: 'Tilpass',
    scheduleStartTimeDesc: 'Velg starttid for det du legger til i timeplanen',
    addToSchedule: 'Legg til i tidsplanen',
    timeBlockTitleDesc: 'Tittel på tidsblokken for tidsplanvisning',
    selectAWorkout: 'Velg en treningsøkt',
    heatScheduleWorkoutDesc: 'Velg en treningsøkt du vil planlegge varme for',
    selectADivision: 'Velg en klasse',
    heatScheduleDivisionDesc: 'Velg en avdeling du vil planlegge oppvarminger for',
    eventsToSchedule: 'Arrangementer å planlegge',
    eventsToScheduleDesc: 'Velg en eller flere hendelser du vil planlegge forberedelser til',
    events: 'arrangementer',
    timeBlock: 'Time Block',
    currentConfiguration: 'Gjeldende konfigurasjon',
    scheduleWorkoutTitleDesc: 'Tittelen på treningsstedet som vises på timeplanen',
    scheduleWorkoutDescriptionDesc: 'Innhold med rik tekst som vil vises i timeplanen for denne treningsplassen',
    editTimeBlock: 'Rediger tidsblokk',
    pointsTablePreview: 'Forhåndsvisning av poengtabell',
    excludeWorkout: 'Vil du ekskludere denne testen fra divisjonens resultatliste?',
    confirmExcludeWorkout: 'Denne handlingen vil fjerne testen fra denne divisjonen, så vel som poengpolitikken. Denne testen vises ikke ved resultatregistrering av atletpoeng, og heller ikke på poenglisten for denne divisjonen.',
    applyToAllDivisions: 'Vil du bruke disse innstillingene på alle divisjoner for denne testen?',
    confirmApplyToAllDivisions: 'Denne handlingen vil gjelde de gjeldende lagrede treningspolicyene for ALLE divisjoner. Alle eksisterende poengretningslinjer for denne testen blir overskrevet. Dette påvirker ikke ekskluderte treningsøkter.',
    areYouSureYouWantToProceed: 'Er du sikker på at du vil fortsette?',
    yesApplyToAll: 'Ja, gjelder for alle',
    yesExclude: 'Ja, ekskluder',
    basicSetup: 'Grunnleggende oppsett',
    brandIdentity: 'Merkeidentitet',
    pleaseLimitSenderName: 'Begrens navnet til mindre enn 50 tegn og er ikke en e-postadresse.',
    pleaseEnterAValidUrl: 'Vennligst skriv inn en gyldig url.',
    theme: 'Tema',
    themeDesc: 'Velg et tema for å endre stilen til destinasjonssidene. Du kan videre tilpasse et tema ved å velge farger som samsvarer med merkevaren din.',
    currentTheme: 'Gjeldende tema',
    themeOptions: 'Temaalternativer',
    customizeTheme: 'Tilpass tema',
    customizeThemeDesc: 'Velg farger for å overstyre {name} -temaet for denne konkurransen.',
    primaryBrand: 'Primærmerke',
    primaryText: 'Primær tekst',
    primaryBackground: 'Primær bakgrunn',
    secondaryText: 'Sekundær tekst',
    secondaryBackground: 'Sekundær bakgrunn',
    buttonBackground: 'Knapp Bakgrunn',
    buttonText: 'Knappetekst',
    secondaryButtonBackground: 'Sekundær knapp bakgrunn',
    secondaryButtonText: 'Sekundær knappetekst',
    pageBackground: 'Side bakgrunn',
    thisWorkoutIsCurrentlyExcludedFrom: 'Denne testen er for øyeblikket ekskludert fra {title}. Klikk <strong>Inkluder for</strong> å legge den tilbake.',
    include: 'Inkludere',
    activeCompetitions: 'Aktive konkurranser',
    eventDate: 'Hendelsesdato',
    createdDate: 'opprettet dato',
    owner: 'Eieren',
    searchForACompetition: 'Søk etter en konkurranse',
    visitLandingPage: 'Besøk destinasjonssiden',
    orgFee: 'Org. Avgift',
    athFee: 'Ath. Avgift',
    athPays: 'Ath. Betaler',
    scoringLinks: 'Poenglenker',
    logs: 'Tømmerstokker',
    timestamp: 'Tidsstempel',
    user: 'Bruker',
    action: 'Handling',
    data: 'Data',
    leaderboard: 'Leaderboard',
    ties: 'Slips',
    athleteSubmitsScore: 'Utøver sender inn resultat',
    platformFee: 'Plattformgebyr',
    platformFeeDesc: 'Plattformavgiften er et fast beløp i konkurransevaluta pluss en% av transaksjonen',
    currencyDesc: 'Valutaen for hele konkurransen inkludert fast avgift.',
    platformFeeFlatDesc: 'Gebyret i hele heltall for {currency}. For desimalbaserte valutaer som USD vil det mesteparten av tiden være multiplisert med 100 (f.eks. $ 5 skal angis som 500)',
    downloadScoringTemplate: 'Last ned poengmal',
    publishCompetition: 'Publiser konkurranse',
    unpublishCompetition: 'Opphev publisering av konkurranse',
    disableScheduling: 'Deaktiver planlegging',
    enableScheduling: 'Aktiver planlegging',
    disableSponsorship: 'Deaktiver sponsing',
    enableSponsorship: 'Aktiver sponsing',
    disableDevKit: 'Deaktiver Dev Kit',
    enableDevKit: 'Aktiver Dev Kit',
    disableRefunds: 'Deaktiver refusjoner',
    enableRefunds: 'Aktiver refusjoner',
    makeRegularComptition: 'Lag regelmessig konkurranse',
    makeATestCompetition: 'Lag en testkonkurranse',
    enterEmail: 'Skriv inn e-post',
    getActivationLink: 'Få aktiveringskobling',
    processing: 'Behandling...',
    rejected: 'Avvist',
    refunded: 'Refunderes',
    reverse: 'Omvendt',
    refund: 'Refusjon',
    testError: 'Testfeil',
    testRejection: 'Test avvisning',
    staffDashboard: 'Personal Dashboard',
    newUsers: 'Nye brukere',
    createdCompetitions: 'Laget konkurranser',
    refundRequests: 'Refusjonsforespørsler',
    emailActivationLinks: 'E-postaktiveringskoblinger',
    youDoNotHavePermission: 'Det ser ikke ut til at du har tilgang til dette.',
    ticketsNameDesc: 'Navn på personen som skal motta billettene.',
    ticketsEmailDesc: 'E-post til personen som skal motta billettene.',
    details: 'Detaljer',
    yourRevenue: 'Inntektene dine',
    collectedFees: 'Samlede avgifter',
    transactions: 'Transaksjoner',
    nevermind: 'Glem det',
    yesCancel: 'Ja, Avbryt',
    notEnoughFunds: 'Fyll opp Stripe-kontoen for å tilbakebetale',
    all: 'Alle',
    orLess: 'eller mindre',
    enterRefundAmount: 'Angi et beløp for refusjon.',
    refundHigherThanRevenue: 'Dette er mer enn den opprinnelige transaksjonen av',
    tooMuch: 'For mye',
    deleteRegistrationAndPurchases: 'Slett registrering og / eller kjøp.',
    whatDivisionsWillYouBeFeaturing: 'Hvilke divisjoner vil du ha?',
    whatDivisionsWillYouBeFeaturingDesc: 'Vi har lagt til noen få eksempler for å komme i gang. Du kan dra & amp; slipp hver klasse for å endre rekkefølgen på listen.',
    purchasesDisabled: 'Kjøp deaktivert',
    purchasesDisabledDesc: 'For øyeblikket er kjøp deaktivert. Prøv igjen senere.',
    addARegistration: 'Legg til en registrering',
    mustBeLoggedInForFeature: 'Du må være logget inn for denne funksjonen.',
    scheduleHasntBeenPublished: 'En tidsplan er ikke publisert ennå.',
    heats: 'Varmes opp',
    mySchedule: 'Min timeplan',
    stripeDashboard: 'Stripe Dashboard',
    chargesAreDisabled: 'Kostnader er for øyeblikket deaktivert til problemet med Stripe-kontoen er løst.',
    areYouSureYouWantToDeleteThat: 'Er du sikker på at du vil slette <strong>{that}</strong> ?',
    custom: 'Tilpasset',
    editDay: 'Rediger dag',
    dayTitleDesc: 'Tittelen på dagen din som vises på timeplanen',
    dayDescriptionDesc: 'Innhold med rik tekst som vises på timeplanen for denne dagen',
    whatDayIsThis: 'Hvilken dag er dette?',
    editWorkoutLocation: 'Rediger treningssted',
    addWorkoutLocation: 'Legg til treningssted',
    pasteYourYouTubeUrl: 'Lim inn YouTube-nettadressen din',
    country: 'Land',
    searchForAnAthlete: 'Søk etter en utøvere.',
    member: 'Medlem',
    changeDivision: 'Endre klasse',
    leaderboardPolicy: 'Leaderboard Policy',
    leaderboardPolicyDesc: 'Velg poengpolitikken som skal brukes til å rangere poeng for denne divisjonens resultatliste.',
    customPoints: 'Egendefinerte poeng',
    customPointsDesc: 'Komma avgrensede poeng, i rekkefølge etter plassering, for den tilpassede poengtabellen.',
    leaderboardTiePolicy: 'Retningslinjebindingspolicy',
    leaderboardTiePolicyDesc: 'Velg policyen som skal brukes til å bryte båndene i dette rangertavlens samlede rangering.',
  },

  dateTimeFormats: {
    short: {
      year: 'numeric', month: 'short', day: 'numeric'
    },
    long: {
      year: 'numeric', month: 'short', day: 'numeric',
      hour: 'numeric', minute: 'numeric', hour12: false
    }
  },

  numberFormats: {
    currency: {
      style: 'currency', currency: 'NOK'
    }
  }
};
